// 'use client';
// import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import React from 'react';
// import {
//    Box,
//    Drawer,
//    DrawerBody,
//    DrawerCloseButton,
//    DrawerContent,
//    DrawerHeader,
//    DrawerOverlay,
//    Flex,
//    Input,
//    InputGroup,
//    Spinner,
//    Table,
//    Tbody,
//    Td,
//    Text,
//    Tr,
//    useColorMode,
//    useColorModeValue,
//    useDisclosure,
//    useOutsideClick,
// } from '@chakra-ui/react';
// import Select from 'react-select';
// import Card from 'components/card/Card';
// import { GridItem } from '@chakra-ui/react';
// import nodata from 'assets/img/nfts/no data.svg';
// import { Button, Image, Grid } from '@chakra-ui/react';
// import Download from '../../../../assets/img/nfts/download.svg';
// import xls from '../../../../../src/assets/img/nfts/xls.svg';
// import json from '../../../../../src/assets/img/nfts/json.svg';
// import back from '../../../../../src/assets/img/nfts/back.svg';
// import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//    clearCacheReport,
//    deleteReportFormat,
//    getReportFormat,
//    getReportSerialWiseHistory,
// } from '../../../../redux/actions/reports';
// import moment from 'moment';
// import ColumnShowHide from '../components/Columnshowhide';
// import { useBusinessType, useGlobal } from '../../../../contexts';
// import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
// import { getShareCompanyOptions } from 'utils/util';
// import DotIcon from '../../../../assets/img/nfts/dot.svg';
// import { stockDrop, stockStatusDrop } from 'constants';
// import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
// import { LuRefreshCcw } from 'react-icons/lu';
// import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
// import { motion, view } from 'framer-motion';
// import { MdCompress, MdDelete, MdExpand } from 'react-icons/md';
// import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
// import SalesDetails from 'components/salesDetails/SalesDetails';
// import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
// import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
// import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
// import { getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
// import { getIssueInventory } from '../../../../redux/actions/issueInventory';
// import { getAccountById } from '../../../../redux/actions/account';
// import {
//    deletePurchaseReturnInvoice,
//    getSinglePurchaseReturn,
//    getSinglePurchaseReturnWithPrevAndNext,
// } from '../../../../redux/actions/purchaseReturnInvoice';
// import {
//    deleteSaleReturnInvoice,
//    getSingleSalesReturnWithPrevAndNext,
// } from '../../../../redux/actions/salesReturnInvoice';
// import { deleteRecord } from 'utils/util';
// import { useUser } from 'contexts';
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import { LucideEdit } from 'lucide-react';
// import { FiPlusCircle } from 'react-icons/fi';
// import { IoFilterOutline } from 'react-icons/io5';
// import ItemSerialwiseHistoryFilter from '../components/ItemSerialWiseHistoryFilter';
// import { deleteRecordForSales } from 'utils/util';
// import Loader from 'views/admin/default/Loader';

// const MotionFlex = motion(Flex);
// const MotionSearchIcon = motion(SearchIcon);
// const MIN_LOADING_TIME = 300;

// const ItemSerialwiseHistory = () => {
//    // Constants
//    const textColor = useColorModeValue('secondaryGray.900', 'white');
//    const backgroundColor = useColorModeValue('white', '#101F4A');
//    const bg = useColorModeValue('#f2f7f2', '#1a254b');
//    const icon = useColorModeValue('#000000', '#ffffff');
//    const { colorMode } = useColorMode();
//    const isDark = colorMode === 'dark';

//    // Context and Redux
//    const { companyList } = useGlobal();
//    const { userGlobalSettingsData } = useGlobal();
//    const { businessTypes } = useBusinessType();
//    const dispatch = useDispatch();
//    const serialWiseHistory = useSelector((state) => state.reports?.serialWiseHistory || []);
//    const dbName = localStorage.getItem('dbName');

//    // report format
//    const reportformat = useSelector((state) => state.reports?.reportFormat || []);
//    const [reportType, setReportType] = useState('Default');
//    const [editData, setEditData] = useState({}); // State to store selected value
//    const [isEditShowHide, setIsEditShowHide] = useState(false); // State to store selected value
//    const [isShowHideColumn, setIsShowHideColumn] = useState(false);
//    const [showHideData, setShowHideData] = useState({});
//    const [formatType, setFormatType] = useState('Default');
//    const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
//    const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
//    const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
//    const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
//    const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
//    const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
//    const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
//    const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
//    const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
//    const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
//    const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
//    const allowedDefNames = ['Item + Serial-Wise History'];
//    const dynamicOptions = reportformat
//       .filter((item) => item?.defName && allowedDefNames.includes(item?.defName))
//       .map((item) => ({
//          id: item.id,
//          value: item.defName && item.title,
//          label: item.title,
//          isDynamic: true,
//          formatData: item,
//       }));
//    const dynamicOptionValues = dynamicOptions.find((option) => option.value === reportType);
//    const isStaticReportType = ['Default'].includes(reportType);
//    const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
//    const { user } = useUser();
//    const [entityType, setEntityType] = useState([]);
//    const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
//    const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
//    const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
//    const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
//    const singleEntity = useSelector((state) => {
//       if (entityType === 'receivemaster') {
//          return state?.receiveInventory?.single || {};
//       } else if (entityType === 'issuemaster') {
//          return state?.issueInventory?.single || {};
//       } else {
//          return {};
//       }
//    });
//    const companyId = Number(localStorage.getItem('companyId'));
//    const userRights = user?.user?.userRights || user?.userRights;
//    const saleInvoiceRight = Array.isArray(userRights)
//       ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
//       : null;
//    const saleReturnRight = Array.isArray(userRights)
//       ? userRights.find((right) => right.companyId === companyId)?.salereturn
//       : null;
//    const purchaseInvoiceRight = Array.isArray(userRights)
//       ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
//       : null;
//    const purchaseReturnRight = Array.isArray(userRights)
//       ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
//       : null;
//    const account = useSelector((state) => state.account.single);
//    const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
//    const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
//    const viewDatasi = useSelector((state) => state.sales?.single);
//    const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
//    const { viewDetail, paginate } = useMemo(() => {
//       const data =
//          entityType === 'purchasereturn'
//             ? viewDatapr?.data[0]
//             : entityType === 'salereturn'
//                ? viewDatasr?.data[0]
//                : entityType === 'saleinvoice'
//                   ? viewDatasi
//                   : entityType === 'purchaseinvoice'
//                      ? viewDatapi
//                      : null;

//       const pagination =
//          entityType === 'purchasereturn'
//             ? viewDatapr?.pagination
//             : entityType === 'salereturn'
//                ? viewDatasr?.pagination
//                : entityType === 'saleinvoice'
//                   ? viewDatasi?.pagination
//                   : entityType === 'purchaseinvoice'
//                      ? viewDatapi?.pagination
//                      : null;

//       return { viewDetail: data, paginate: pagination };
//    }, [
//       entityType,
//       viewDatapr?.data,
//       viewDatapr?.pagination,
//       viewDatasr?.data,
//       viewDatasr?.pagination,
//       viewDatasi,
//       viewDatapi,
//    ]);

//    // Refs
//    const abortControllerRef = useRef(null);
//    const wrapperRef = useRef();

//    // State
//    const [allExpanded, setAllExpanded] = useState(false);
//    const [itemWiseSelected, setItemWiseSelected] = useState(null);
//    const [stockWiseSelected, setStockWiseSelected] = useState(null);
//    const [companyFilter, setCompanyFilter] = useState([]);
//    const [expandedItems, setExpandedItems] = useState({});
//    const [searchQuery, setSearchQuery] = useState('');
//    const [isLoading, setIsLoading] = useState(false);
//    const [dateRange, setDateRange] = useState(() => {
//       const today = new Date();
//       const sevenDaysAgo = new Date();
//       sevenDaysAgo.setDate(today.getDate() - 6);

//       return {
//          fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
//          toDate: today.toISOString().split('T')[0], // today
//       };
//    });

//    // Disclosures
//    const { isOpen, onOpen, onClose } = useDisclosure();
//    const [expanded, setExpanded] = useState(false);

//    useOutsideClick({
//       ref: wrapperRef,
//       handler: () => {
//          if (searchQuery === '') setExpanded(false);
//       },
//    });

//    // Initialize expanded state for all items when data loads
//    useEffect(() => {
//       if (serialWiseHistory.length > 0) {
//          const newExpanded = {};
//          serialWiseHistory.forEach((companyData) => {
//             const companyKey = `company-${companyData.companyId}`;
//             newExpanded[companyKey] = true;

//             if (companyData.items) {
//                companyData.items.forEach((itemData) => {
//                   const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
//                   newExpanded[itemKey] = true;
//                });
//             }
//          });
//          setExpandedItems(newExpanded);
//       }
//    }, [serialWiseHistory]);

//    // Memoized values
//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );

//    const companyIds = useMemo(
//       () =>
//          companyFilter.length > 0
//             ? companyFilter
//             : localStorage.getItem('companyId')
//                ? [parseInt(localStorage.getItem('companyId'))]
//                : [],
//       [companyFilter],
//    );

//    // Initialize default values
//    const storedCompanyId = localStorage.getItem('companyId');
//    useEffect(() => {
//       if (storedCompanyId && companyList.length > 0) {
//          const companyId = parseInt(storedCompanyId);
//          const matchingCompany = companyList.find((comp) => comp.id === companyId);
//          if (matchingCompany) {
//             setCompanyFilter([matchingCompany.id]);
//          }
//       }

//       if (businessTypes?.businessType === 'MOBILE') {
//          setItemWiseSelected({ value: stockDrop[0].id, label: stockDrop[0].name });
//          setStockWiseSelected({ value: stockStatusDrop[2].id, label: stockStatusDrop[2].name });
//       }
//    }, [companyList, businessTypes, storedCompanyId]);

//    // Data fetching with optimized search
//    const fetchData = useCallback(async () => {
//       // Validate companyIds - must be an array with at least one valid number
//       if (
//          !Array.isArray(companyIds) ||
//          companyIds.length === 0 ||
//          companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0)
//       ) {
//          console.log('Invalid company IDs, skipping API call');
//          return;
//       }

//       if (abortControllerRef.current) {
//          abortControllerRef.current.abort();
//       }

//       abortControllerRef.current = new AbortController();
//       const startTime = Date.now();
//       setIsLoading(true);

//       try {
//          // Filter out any invalid IDs just to be safe
//          const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

//          if (dateRange.fromDate && dateRange.toDate && validCompanyIds.length > 0) {
//             await dispatch(
//                getReportSerialWiseHistory({
//                   companyIds: validCompanyIds.join(','),
//                   // fromDate: dateRange.fromDate,
//                   // toDate: dateRange.toDate,
//                   // stockStatus: stockWiseSelected?.value,
//                   search: searchQuery.trim(),
//                }),
//                { signal: abortControllerRef.current.signal },
//             );
//          }
//       } catch (error) {
//          if (error.name !== 'AbortError') {
//             console.error('Error fetching serial wise history:', error);
//          }
//       } finally {
//          const elapsedTime = Date.now() - startTime;
//          const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);

//          if (remainingTime > 0) {
//             await new Promise((resolve) => setTimeout(resolve, remainingTime));
//          }

//          setIsLoading(false);
//          abortControllerRef.current = null;
//       }
//    }, [dispatch, companyIds, stockWiseSelected, searchQuery, dateRange]);

//    // Add this useEffect to automatically fetch data when all required dependencies are available
//    useEffect(() => {
//       // Validate all parameters before fetching data
//       const hasValidCompanyIds =
//          Array.isArray(companyIds) &&
//          companyIds.length > 0 &&
//          !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
//       const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

//       if (hasValidCompanyIds && hasValidDateRange) {
//          fetchData();
//       }
//    }, [companyIds, dateRange, fetchData]);

//    // Debounced search effect
//    useEffect(() => {
//       const timer = setTimeout(() => {
//          fetchData();
//       }, 200);

//       return () => {
//          clearTimeout(timer);
//          if (abortControllerRef.current) {
//             abortControllerRef.current.abort();
//          }
//       };
//    }, [fetchData]);

//    const fetchReportType = useCallback(async () => {
//       await dispatch(getReportFormat());
//    }, [dispatch]);

//    // Debounced search effect
//    useEffect(() => {
//       fetchReportType();
//    }, [fetchReportType]);

//    // Search handler with debounce
//    const handleSearchChange = useCallback((e) => {
//       const value = e.target.value;
//       setSearchQuery(value);
//    }, []);

//    // Handlers
//    const handleDateRangeChange = useCallback((dates) => {
//       if (!dates || dates.length !== 2) return;
//       const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
//       setDateRange({ fromDate: from, toDate: to });
//    }, []);

//    const expandAll = useCallback(() => {
//       const newExpanded = {};
//       serialWiseHistory.forEach((companyData) => {
//          const companyKey = `company-${companyData.companyId}`;
//          newExpanded[companyKey] = true;

//          if (companyData.items) {
//             companyData.items.forEach((itemData) => {
//                const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
//                newExpanded[itemKey] = true;
//             });
//          }
//       });
//       setExpandedItems(newExpanded);
//       setAllExpanded(true);
//    }, [serialWiseHistory]);

//    const collapseAll = useCallback(() => {
//       const newExpanded = {};
//       serialWiseHistory.forEach((companyData) => {
//          const companyKey = `company-${companyData.companyId}`;
//          newExpanded[companyKey] = true; // Keep companies expanded

//          if (companyData.items) {
//             companyData.items.forEach((itemData) => {
//                const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
//                newExpanded[itemKey] = false; // Collapse all items
//             });
//          }
//       });
//       setExpandedItems(newExpanded);
//       setAllExpanded(false);
//    }, [serialWiseHistory]);

//    const handleRefresh = useCallback(() => {
//       fetchData();
//    }, [fetchData]);

//    const toggleExpand = useCallback((id) => {
//       setExpandedItems((prev) => ({
//          ...prev,
//          [id]: !prev[id],
//       }));
//    }, []);

//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setCompanyFilter(selectedOptions ? selectedOptions : []);
//    }, []);

//    // Formatting functions
//    const formatDateToDDMMYYYY = useCallback((dateString) => {
//       if (!dateString) return '-';
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return '-';
//       const day = String(date.getDate()).padStart(2, '0');
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//    }, []);

//    // Group items by item_id to consolidate duplicate items
//    const groupItemsByItemId = useCallback((items) => {
//       if (!items) return [];

//       const grouped = items.reduce((acc, item) => {
//          if (!acc[item.item_id]) {
//             acc[item.item_id] = {
//                item_id: item.item_id,
//                item_name: item.item_name,
//                total_transactions: 0,
//                transactions: [],
//             };
//          }

//          acc[item.item_id].total_transactions += item.total_transactions;
//          acc[item.item_id].transactions.push(...item.transactions);

//          return acc;
//       }, {});

//       return Object.values(grouped);
//    }, []);

//    const exportToExcel = () => {
//       if (!serialWiseHistory || serialWiseHistory.length === 0) {
//          alert('No data to export');
//          return;
//       }

//       try {
//          // Create a new workbook
//          const wb = XLSX.utils.book_new();
//          const wsData = [];

//          // Check if xlsx-js-style is available for advanced styling
//          const hasXLSXStyle = typeof XLSXStyle !== 'undefined' || typeof XLSX.writeFileXLSX !== 'undefined';

//          // Helper function to create styled cells
//          const createStyledCell = (value, style = {}) => {
//             // Basic cell structure
//             const cell = {
//                v: value,
//                t: typeof value === 'number' ? 'n' : 's',
//             };

//             // Only add styles if xlsx-js-style is available
//             if (hasXLSXStyle && style && Object.keys(style).length > 0) {
//                cell.s = style;
//             }

//             return cell;
//          };

//          // Helper function to convert backend color to Excel RGB (6 digits)
//          const convertBackendColorToExcel = (backendColor) => {
//             if (!backendColor) return '000000';

//             if (backendColor.startsWith('#')) {
//                return backendColor.substring(1).toUpperCase().padStart(6, '0');
//             }

//             if (backendColor.startsWith('0xff') || backendColor.startsWith('0xFF')) {
//                const hex = backendColor.substring(4);
//                return hex.toUpperCase().padStart(6, '0');
//             }

//             return '000000';
//          };

//          // Get column configuration based on static or dynamic format
//          const getColumnConfig = () => {
//             // For static format, use predefined columns
//             if (isStaticReportType) {
//                let staticColumns = [];

//                if (itemWiseSelected?.value === 0) {
//                   // Item + Serial-Wise
//                   staticColumns = [
//                      { key: 'serial_no', title: 'Serial No', accessor: 'serial_no', width: 20 },
//                      { key: 'transaction_at', title: 'Date', accessor: 'transaction_at', isDate: true, width: 15 },
//                      { key: 'daybook_name', title: 'Daybook', accessor: 'daybook_name', width: 20 },
//                      { key: 'doc_no', title: 'Doc', accessor: 'doc_no', width: 15 },
//                      { key: 'account_name', title: 'Party', accessor: 'account_name', width: 25 },
//                      { key: 'item_rate', title: 'Item Rate', accessor: 'item_rate', isNumeric: true, width: 15 },
//                      {
//                         key: 'quantity_factor',
//                         title: 'Quantity',
//                         accessor: 'quantity_factor',
//                         isNumeric: true,
//                         width: 15,
//                      },
//                      { key: 'line_amount', title: 'Amount', accessor: 'line_amount', isNumeric: true, width: 15 },
//                   ];
//                } else if (itemWiseSelected?.value === 1) {
//                   // Item-wise
//                   staticColumns = [
//                      { key: 'item_name', title: 'Item Name', accessor: 'item_name', width: 30 },
//                      {
//                         key: 'total_transactions',
//                         title: 'Quantity',
//                         accessor: 'total_transactions',
//                         isNumeric: true,
//                         width: 20,
//                      },
//                      { key: 'total_amount', title: 'Amount', accessor: 'total_amount', isNumeric: true, width: 20 },
//                   ];
//                } else if (itemWiseSelected?.value === 2) {
//                   // Serial-Wise
//                   staticColumns = [
//                      { key: 'serial_no', title: 'Serial No', accessor: 'serial_no', width: 20 },
//                      { key: 'transaction_at', title: 'Date', accessor: 'transaction_at', isDate: true, width: 15 },
//                      { key: 'daybook_name', title: 'Daybook', accessor: 'daybook_name', width: 20 },
//                      { key: 'doc_no', title: 'Doc', accessor: 'doc_no', width: 15 },
//                      { key: 'account_name', title: 'Party', accessor: 'account_name', width: 25 },
//                      { key: 'transaction_type', title: 'Transaction Type', accessor: 'transaction_type', width: 20 },
//                      { key: 'line_amount', title: 'Amount', accessor: 'line_amount', isNumeric: true, width: 15 },
//                   ];
//                }

//                // Add default styling config for static columns
//                return staticColumns.map((col) => ({
//                   ...col,
//                   config: {
//                      title: col.title,
//                      isShow: true,
//                      color: '000000', // Black for static
//                      isBold: false,
//                      isItalic: false,
//                      orderNo: 0,
//                      flex: 1,
//                   },
//                }));
//             }

//             // For dynamic format, use configuration from viewJson
//             const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

//             const getColumnInfo = (defName) => {
//                const viewItem = viewJson.find(
//                   (item) =>
//                      item?.defName?.toLowerCase() === defName.toLowerCase() ||
//                      item?.title?.toLowerCase() === defName.toLowerCase(),
//                );

//                if (!viewItem) {
//                   return {
//                      title: defName,
//                      isShow: true,
//                      color: '000000',
//                      isBold: false,
//                      isItalic: false,
//                      orderNo: 0,
//                      flex: 1,
//                   };
//                }

//                return {
//                   title: viewItem.title || defName,
//                   isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
//                   color: viewItem.color ? convertBackendColorToExcel(viewItem.color) : '000000',
//                   isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
//                   isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
//                   orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
//                   flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
//                };
//             };

//             // Define all possible columns based on view type
//             let allColumns = [];

//             // Safe access to itemWiseSelected
//             const viewValue = itemWiseSelected?.value ?? 0;

//             if (viewValue === 0) {
//                allColumns = [
//                   { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no', width: 20 },
//                   { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true, width: 15 },
//                   { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name', width: 20 },
//                   { key: 'doc_no', defName: 'doc', accessor: 'doc_no', width: 15 },
//                   { key: 'account_name', defName: 'party', accessor: 'account_name', width: 25 },
//                   { key: 'item_rate', defName: 'itemrate', accessor: 'item_rate', isNumeric: true, width: 15 },
//                   {
//                      key: 'quantity_factor',
//                      defName: 'quantity',
//                      accessor: 'quantity_factor',
//                      isNumeric: true,
//                      width: 15,
//                   },
//                   { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true, width: 15 },
//                ];
//             } else if (viewValue === 1) {
//                allColumns = [
//                   { key: 'item_name', defName: 'itemname', accessor: 'item_name', width: 30 },
//                   {
//                      key: 'total_transactions',
//                      defName: 'quantity',
//                      accessor: 'total_transactions',
//                      isNumeric: true,
//                      width: 20,
//                   },
//                   { key: 'total_amount', defName: 'amt', accessor: 'total_amount', isNumeric: true, width: 20 },
//                ];
//             } else if (viewValue === 2) {
//                allColumns = [
//                   { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no', width: 20 },
//                   { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true, width: 15 },
//                   { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name', width: 20 },
//                   { key: 'doc_no', defName: 'doc', accessor: 'doc_no', width: 15 },
//                   { key: 'account_name', defName: 'party', accessor: 'account_name', width: 25 },
//                   { key: 'transaction_type', defName: 'transactiontype', accessor: 'transaction_type', width: 20 },
//                   { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true, width: 15 },
//                ];
//             }

//             const configuredColumns = allColumns
//                .map((col) => ({ ...col, config: getColumnInfo(col.defName) }))
//                .filter((col) => col.config.isShow !== false)
//                .sort((a, b) => (a.config.orderNo || 0) - (b.config.orderNo || 0));

//             return configuredColumns;
//          };

//          // Styles for Excel cells - simplified for better compatibility
//          const styles = {
//             reportTitle: {
//                font: { bold: true, sz: 16 },
//                alignment: { horizontal: 'center' },
//                fill: { fgColor: { rgb: 'FFFFFF' } },
//             },
//             dateRange: {
//                font: { italic: true, sz: 12 },
//                alignment: { horizontal: 'center' },
//             },
//             companyHeader: {
//                font: { bold: true, sz: 14, color: { rgb: '0000FF' } },
//                fill: { fgColor: { rgb: 'E6E6FA' } },
//                alignment: { horizontal: 'left' },
//             },
//             companyTotals: {
//                font: { bold: true, sz: 12, color: { rgb: '0000FF' } },
//                fill: { fgColor: { rgb: 'E6E6FA' } },
//                alignment: { horizontal: 'left' },
//             },
//             tableHeader: {
//                font: { bold: true, sz: 12 },
//                fill: { fgColor: { rgb: 'F1F0E8' } },
//                alignment: { horizontal: 'center' },
//             },
//             itemHeader: {
//                font: { bold: true, sz: 11 },
//                fill: { fgColor: { rgb: 'E6E6E6' } },
//                alignment: { horizontal: 'left' },
//             },
//             totalRow: {
//                font: { bold: true, sz: 11 },
//                fill: { fgColor: { rgb: 'D3D3D3' } },
//                alignment: { horizontal: 'left' },
//             },
//             oddRow: {
//                font: { sz: 10 },
//                fill: { fgColor: { rgb: 'FFFFFF' } },
//             },
//             evenRow: {
//                font: { sz: 10 },
//                fill: { fgColor: { rgb: 'F8FAFC' } },
//             },
//          };

//          const columnConfig = getColumnConfig();
//          let currentRow = 0;
//          const mergeRanges = [];

//          // Safe date formatting
//          const safeDateFormat = (dateValue) => {
//             try {
//                if (!dateValue) return '';
//                if (typeof formatDateToDDMMYYYY === 'function') {
//                   return formatDateToDDMMYYYY(dateValue);
//                }
//                // Fallback date formatting
//                const date = new Date(dateValue);
//                if (isNaN(date.getTime())) return dateValue.toString();
//                return date.toLocaleDateString('en-GB');
//             } catch (error) {
//                console.warn('Date formatting error:', error);
//                return dateValue?.toString() || '';
//             }
//          };

//          // Helper function to format cell value
//          const formatCellValue = (value, column) => {
//             try {
//                if (value === null || value === undefined) return '';
//                if (value === 0) return 0;

//                if (column?.isDate && value) {
//                   return safeDateFormat(value);
//                }
//                if (column?.isNumeric) {
//                   const numValue = parseFloat(value);
//                   return isNaN(numValue) ? 0 : numValue;
//                }
//                return value.toString();
//             } catch (error) {
//                console.warn('Cell value formatting error:', error);
//                return '';
//             }
//          };

//          // Helper function to get cell style with dynamic formatting
//          const getCellStyle = (baseStyle, column, rowIndex = 0) => {
//             try {
//                let cellStyle = JSON.parse(JSON.stringify(baseStyle));

//                // Apply dynamic formatting if available and xlsx-js-style is present
//                if (hasXLSXStyle && column?.config) {
//                   if (column.config.color && column.config.color !== '000000') {
//                      cellStyle.font = cellStyle.font || {};
//                      cellStyle.font.color = { rgb: column.config.color };
//                   }
//                   if (column.config.isBold) {
//                      cellStyle.font = cellStyle.font || {};
//                      cellStyle.font.bold = true;
//                   }
//                   if (column.config.isItalic) {
//                      cellStyle.font = cellStyle.font || {};
//                      cellStyle.font.italic = true;
//                   }
//                }

//                // Apply specific formatting based on column type
//                if (column) {
//                   if (column.isNumeric) {
//                      cellStyle.numFmt = '#,##0.00';
//                      cellStyle.alignment = cellStyle.alignment || {};
//                      cellStyle.alignment.horizontal = 'right';
//                   } else if (column.isDate) {
//                      cellStyle.numFmt = 'dd-mm-yyyy';
//                      cellStyle.alignment = cellStyle.alignment || {};
//                      cellStyle.alignment.horizontal = 'center';
//                   } else {
//                      cellStyle.alignment = cellStyle.alignment || {};
//                      cellStyle.alignment.horizontal = 'left';
//                   }
//                }

//                return cellStyle;
//             } catch (error) {
//                console.warn('Style generation error:', error);
//                return baseStyle;
//             }
//          };

//          // Safe date range formatting
//          const fromDateStr = dateRange?.fromDate ? safeDateFormat(dateRange.fromDate) : 'N/A';
//          const toDateStr = dateRange?.toDate ? safeDateFormat(dateRange.toDate) : 'N/A';

//          // Add report title
//          wsData.push([createStyledCell('Item + Serialwise History Report', styles.reportTitle)]);
//          mergeRanges.push({
//             s: { r: currentRow, c: 0 },
//             e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
//          });
//          currentRow++;

//          // Add date range
//          wsData.push([createStyledCell(`From ${fromDateStr} to ${toDateStr}`, styles.dateRange)]);
//          mergeRanges.push({
//             s: { r: currentRow, c: 0 },
//             e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
//          });
//          currentRow++;

//          // Add format type if dynamic
//          if (!isStaticReportType) {
//             wsData.push([createStyledCell(`Format: ${reportType || 'Dynamic'}`, styles.dateRange)]);
//             mergeRanges.push({
//                s: { r: currentRow, c: 0 },
//                e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
//             });
//             currentRow++;
//          }

//          wsData.push([]); // Empty row
//          currentRow++;

//          // Safe data processing with proper null checks
//          if (!Array.isArray(serialWiseHistory)) {
//             throw new Error('serialWiseHistory is not an array');
//          }

//          // Process each company
//          serialWiseHistory.forEach((companyData, companyIndex) => {
//             try {
//                if (!companyData || !companyData.items) {
//                   console.warn(`Company data at index ${companyIndex} is invalid:`, companyData);
//                   return; // Skip invalid company data
//                }

//                // Group items by item ID
//                let groupedItems = [];
//                if (typeof groupItemsByItemId === 'function') {
//                   groupedItems = groupItemsByItemId(companyData.items);
//                } else {
//                   // Fallback grouping logic
//                   groupedItems = companyData.items.map((item) => ({
//                      ...item,
//                      transactions: item.transactions || [],
//                   }));
//                }

//                // Calculate company totals with safe arithmetic
//                const companyTotals = groupedItems.reduce(
//                   (acc, item) => {
//                      if (!item || !Array.isArray(item.transactions)) {
//                         return acc;
//                      }

//                      const itemTotal = item.transactions.reduce(
//                         (subAcc, transaction) => {
//                            const amount = parseFloat(transaction?.line_amount) || 0;
//                            return {
//                               transactions: subAcc.transactions + 1,
//                               amount: subAcc.amount + amount,
//                            };
//                         },
//                         { transactions: 0, amount: 0 },
//                      );
//                      return {
//                         transactions: acc.transactions + itemTotal.transactions,
//                         amount: acc.amount + itemTotal.amount,
//                      };
//                   },
//                   { transactions: 0, amount: 0 },
//                );

//                // Add company header
//                const companyName = companyData.companyName || `Company ${companyIndex + 1}`;
//                wsData.push([createStyledCell(companyName, styles.companyHeader)]);
//                mergeRanges.push({
//                   s: { r: currentRow, c: 0 },
//                   e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
//                });
//                currentRow++;

//                // Add company totals
//                const companyTotalCells = [];
//                companyTotalCells.push(createStyledCell('', styles.companyTotals));
//                companyTotalCells.push(
//                   createStyledCell(`Total Qty: ${companyTotals.transactions}`, styles.companyTotals),
//                );
//                companyTotalCells.push(
//                   createStyledCell(
//                      `Total Amount: ₹${companyTotals.amount.toLocaleString('en-IN')}`,
//                      styles.companyTotals,
//                   ),
//                );

//                // Fill remaining cells with styled empty cells
//                while (companyTotalCells.length < Math.max(columnConfig.length, 8)) {
//                   companyTotalCells.push(createStyledCell('', styles.companyTotals));
//                }

//                wsData.push(companyTotalCells);
//                currentRow++;

//                wsData.push([]); // Empty row
//                currentRow++;

//                // Add table headers with column-specific styling
//                const headers = columnConfig.map((col) => {
//                   const headerStyle = JSON.parse(JSON.stringify(styles.tableHeader));

//                   // Apply column-specific styling for dynamic format
//                   if (!isStaticReportType && hasXLSXStyle && col.config) {
//                      if (col.config.color && col.config.color !== '000000') {
//                         headerStyle.font = headerStyle.font || {};
//                         headerStyle.font.color = { rgb: col.config.color };
//                      }
//                      if (col.config.isBold) {
//                         headerStyle.font = headerStyle.font || {};
//                         headerStyle.font.bold = true;
//                      }
//                      if (col.config.isItalic) {
//                         headerStyle.font = headerStyle.font || {};
//                         headerStyle.font.italic = true;
//                      }
//                   }

//                   return createStyledCell(col.config?.title || col.title || col.defName, headerStyle);
//                });

//                wsData.push(headers);
//                currentRow++;

//                // Process items based on view type with better error handling
//                const viewValue = itemWiseSelected?.value ?? 0;

//                if (viewValue === 0) {
//                   // Item + Serial-Wise
//                   groupedItems.forEach((item, itemIndex) => {
//                      try {
//                         if (!item || !Array.isArray(item.transactions)) {
//                            console.warn(`Item at index ${itemIndex} is invalid:`, item);
//                            return;
//                         }

//                         const itemTotal = item.transactions.reduce(
//                            (sum, trans) => sum + (parseFloat(trans?.line_amount) || 0),
//                            0,
//                         );

//                         // Add item header row
//                         const itemHeaderRow = [];
//                         const itemName = item.item_name || `Item ${itemIndex + 1}`;
//                         const totalTransactions = item.total_transactions || item.transactions.length;

//                         itemHeaderRow.push(
//                            createStyledCell(
//                               `${itemName} - Total Qty: ${totalTransactions} | Total Amount: ₹${itemTotal.toLocaleString(
//                                  'en-IN',
//                               )}`,
//                               styles.itemHeader,
//                            ),
//                         );

//                         // Fill remaining cells with styled empty cells
//                         for (let i = 1; i < columnConfig.length; i++) {
//                            itemHeaderRow.push(createStyledCell('', styles.itemHeader));
//                         }

//                         wsData.push(itemHeaderRow);
//                         mergeRanges.push({
//                            s: { r: currentRow, c: 0 },
//                            e: { r: currentRow, c: columnConfig.length - 1 },
//                         });
//                         currentRow++;

//                         // Add transactions with column-specific styling
//                         item.transactions.forEach((transaction, transIndex) => {
//                            try {
//                               const baseRowStyle = transIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

//                               const transactionRow = columnConfig.map((col) => {
//                                  const value = formatCellValue(transaction?.[col.accessor], col);
//                                  const cellStyle = getCellStyle(baseRowStyle, col, transIndex);
//                                  return createStyledCell(value, cellStyle);
//                               });

//                               wsData.push(transactionRow);
//                               currentRow++;
//                            } catch (transError) {
//                               console.warn(`Error processing transaction ${transIndex}:`, transError);
//                            }
//                         });

//                         wsData.push([]); // Empty row after each item
//                         currentRow++;
//                      } catch (itemError) {
//                         console.warn(`Error processing item ${itemIndex}:`, itemError);
//                      }
//                   });
//                } else if (viewValue === 1) {
//                   // Item-wise
//                   groupedItems.forEach((item, itemIndex) => {
//                      try {
//                         const itemTotal =
//                            item.transactions?.reduce((sum, trans) => sum + (parseFloat(trans?.line_amount) || 0), 0) ||
//                            0;
//                         const baseRowStyle = itemIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

//                         const rowData = columnConfig.map((col) => {
//                            let value = '';
//                            if (col.key === 'item_name') value = item.item_name || '';
//                            else if (col.key === 'total_transactions')
//                               value = item.total_transactions || item.transactions?.length || 0;
//                            else if (col.key === 'total_amount') value = itemTotal;

//                            const cellStyle = getCellStyle(baseRowStyle, col, itemIndex);
//                            return createStyledCell(value, cellStyle);
//                         });

//                         wsData.push(rowData);
//                         currentRow++;
//                      } catch (itemError) {
//                         console.warn(`Error processing item-wise data ${itemIndex}:`, itemError);
//                      }
//                   });

//                   // Add company totals row
//                   const totalRowData = columnConfig.map((col) => {
//                      let value = '';
//                      if (col.key === 'item_name') value = 'Company Total';
//                      else if (col.key === 'total_transactions') value = companyTotals.transactions;
//                      else if (col.key === 'total_amount') value = companyTotals.amount;

//                      return createStyledCell(value, styles.totalRow);
//                   });

//                   wsData.push(totalRowData);
//                   currentRow++;
//                } else if (viewValue === 2) {
//                   // Serial-Wise
//                   groupedItems.forEach((item, itemIndex) => {
//                      try {
//                         if (!item || !Array.isArray(item.transactions)) {
//                            return;
//                         }

//                         const itemTotal = item.transactions.reduce(
//                            (sum, trans) => sum + (parseFloat(trans?.line_amount) || 0),
//                            0,
//                         );

//                         // Add item header row
//                         const itemHeaderRow = [];
//                         const itemName = item.item_name || `Item ${itemIndex + 1}`;
//                         itemHeaderRow.push(
//                            createStyledCell(
//                               `${itemName} - Total Amount: ₹${itemTotal.toLocaleString('en-IN')}`,
//                               styles.itemHeader,
//                            ),
//                         );

//                         // Fill remaining cells with styled empty cells
//                         for (let i = 1; i < columnConfig.length; i++) {
//                            itemHeaderRow.push(createStyledCell('', styles.itemHeader));
//                         }

//                         wsData.push(itemHeaderRow);
//                         mergeRanges.push({
//                            s: { r: currentRow, c: 0 },
//                            e: { r: currentRow, c: columnConfig.length - 1 },
//                         });
//                         currentRow++;

//                         // Add transactions with column-specific styling
//                         item.transactions.forEach((transaction, transIndex) => {
//                            try {
//                               const baseRowStyle = transIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

//                               const rowData = columnConfig.map((col) => {
//                                  const value = formatCellValue(transaction?.[col.accessor], col);
//                                  const cellStyle = getCellStyle(baseRowStyle, col, transIndex);
//                                  return createStyledCell(value, cellStyle);
//                               });

//                               wsData.push(rowData);
//                               currentRow++;
//                            } catch (transError) {
//                               console.warn(`Error processing serial transaction ${transIndex}:`, transError);
//                            }
//                         });

//                         wsData.push([]); // Empty row after each item
//                         currentRow++;
//                      } catch (itemError) {
//                         console.warn(`Error processing serial-wise item ${itemIndex}:`, itemError);
//                      }
//                   });
//                }

//                wsData.push([]); // Empty row after each company
//                currentRow++;
//             } catch (companyError) {
//                console.warn(`Error processing company ${companyIndex}:`, companyError);
//             }
//          });

//          // Convert wsData to worksheet
//          const ws = XLSX.utils.aoa_to_sheet(wsData);

//          // Set column widths based on column configuration
//          const colWidths = columnConfig.map((col) => ({ wch: col.width || 15 }));
//          while (colWidths.length < 8) {
//             colWidths.push({ wch: 15 });
//          }
//          ws['!cols'] = colWidths;

//          // Add merge ranges safely
//          if (mergeRanges.length > 0) {
//             ws['!merges'] = mergeRanges;
//          }

//          // Add worksheet to workbook
//          XLSX.utils.book_append_sheet(wb, ws, 'Item Serialwise History');

//          // Generate file name safely
//          const now = new Date();
//          const formatSuffix = isStaticReportType ? '_Static' : '_Dynamic';
//          const safeFileName = `Item_Serialwise_History${formatSuffix}_${now.getFullYear()}${(now.getMonth() + 1)
//             .toString()
//             .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.xlsx`;

//          // Write file - use XLSX.writeFileXLSX if available for styling
//          if (hasXLSXStyle && typeof XLSX.writeFileXLSX !== 'undefined') {
//             XLSX.writeFileXLSX(wb, safeFileName);
//          } else {
//             XLSX.writeFile(wb, safeFileName);
//          }

//          console.log('Excel export completed successfully');
//       } catch (error) {
//          console.error('Error exporting to Excel:', error);

//          // More detailed error information
//          if (error.message) {
//             alert(`Failed to export Excel file: ${error.message}`);
//          } else {
//             alert('Failed to export Excel file. Please check the console for details.');
//          }

//          // Log additional debugging information
//          console.log('Debug info:', {
//             serialWiseHistoryLength: serialWiseHistory?.length,
//             itemWiseSelected: itemWiseSelected,
//             dateRange: dateRange,
//             dynamicOptionValues: dynamicOptionValues,
//             isStaticReportType: isStaticReportType,
//          });
//       }
//    };

//    const exportToPdf = () => {
//       if (!serialWiseHistory || serialWiseHistory.length === 0) {
//          alert('No data to export');
//          return;
//       }

//       try {
//          // Create a new PDF document
//          const doc = new jsPDF({
//             orientation: 'landscape',
//             unit: 'mm',
//          });

//          // Set document properties
//          doc.setProperties({
//             title: 'Item + Serialwise History Report',
//             subject: 'Generated from application',
//             author: 'Your Application',
//             keywords: 'report, item, serialwise, history',
//             creator: 'Your Application',
//          });

//          // Get page width for centering
//          const pdfWidth = doc.internal.pageSize.getWidth();

//          // Add title and date range
//          doc.setFontSize(16);
//          doc.setTextColor(0, 0, 0);
//          doc.setFont('helvetica', 'bold');

//          // Calculate center position for title
//          const title = 'Item + Serialwise History Report';
//          const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
//          const titleX = (pdfWidth - titleWidth) / 2;
//          doc.text(title, titleX, 15);

//          doc.setFontSize(10);
//          doc.setFont('helvetica', 'bold');
//          doc.setTextColor(0, 0, 0);

//          // Calculate center position for date range
//          const dateText = `From ${formatDateToDDMMYYYY(dateRange.fromDate)} to ${formatDateToDDMMYYYY(
//             dateRange.toDate,
//          )}`;
//          const dateWidth = (doc.getStringUnitWidth(dateText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
//          const dateX = (pdfWidth - dateWidth) / 2;
//          doc.text(dateText, dateX, 22);

//          // Get dynamic column configuration
//          const getColumnConfig = () => {
//             const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

//             const convertBackendColor = (backendColor) => {
//                if (!backendColor) return [0, 0, 0]; // Default black
//                if (backendColor.startsWith('#')) {
//                   // Convert hex to RGB array for jsPDF
//                   const hex = backendColor.substring(1);
//                   const r = parseInt(hex.substring(0, 2), 16);
//                   const g = parseInt(hex.substring(2, 4), 16);
//                   const b = parseInt(hex.substring(4, 6), 16);
//                   return [r, g, b];
//                }
//                if (backendColor.startsWith('0xff')) {
//                   const hex = backendColor.substring(4);
//                   const r = parseInt(hex.substring(0, 2), 16);
//                   const g = parseInt(hex.substring(2, 4), 16);
//                   const b = parseInt(hex.substring(4, 6), 16);
//                   return [r, g, b];
//                }
//                return [0, 0, 0]; // Default black
//             };

//             const getColumnInfo = (defName) => {
//                const viewItem = viewJson.find(
//                   (item) =>
//                      item?.defName?.toLowerCase() === defName.toLowerCase() ||
//                      item?.title?.toLowerCase() === defName.toLowerCase(),
//                );

//                if (!viewItem || isStaticReportType) {
//                   return {
//                      title: defName,
//                      isShow: true,
//                      color: [0, 0, 0],
//                      isBold: false,
//                      isItalic: false,
//                      orderNo: 0,
//                      flex: 1,
//                   };
//                }

//                return {
//                   title: viewItem.title || defName,
//                   isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
//                   color: viewItem.color ? convertBackendColor(viewItem.color) : [0, 0, 0],
//                   isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
//                   isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
//                   orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
//                   flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
//                };
//             };

//             // Define all possible columns based on view type
//             let allColumns = [];

//             if (itemWiseSelected?.value === 0) {
//                // Item + Serial-Wise columns (excluding item_name as it will be a separate row)
//                allColumns = [
//                   { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no' },
//                   { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true },
//                   { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name' },
//                   { key: 'doc_no', defName: 'doc', accessor: 'doc_no' },
//                   { key: 'account_name', defName: 'party', accessor: 'account_name' },
//                   { key: 'item_rate', defName: 'itemrate', accessor: 'item_rate', isNumeric: true },
//                   { key: 'quantity_factor', defName: 'quantity', accessor: 'quantity_factor', isNumeric: true },
//                   { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true },
//                ];
//             } else if (itemWiseSelected?.value === 1) {
//                // Item-wise columns
//                allColumns = [
//                   { key: 'item_name', defName: 'itemname', accessor: 'item_name' },
//                   { key: 'total_transactions', defName: 'quantity', accessor: 'total_transactions', isNumeric: true },
//                   { key: 'total_amount', defName: 'amt', accessor: 'total_amount', isNumeric: true },
//                ];
//             } else if (itemWiseSelected?.value === 2) {
//                // Serial-Wise columns (excluding item_name as it will be a separate row)
//                allColumns = [
//                   { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no' },
//                   { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true },
//                   { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name' },
//                   { key: 'doc_no', defName: 'doc', accessor: 'doc_no' },
//                   { key: 'account_name', defName: 'party', accessor: 'account_name' },
//                   { key: 'transaction_type', defName: 'transactiontype', accessor: 'transaction_type' },
//                   { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true },
//                ];
//             }

//             // Get column configuration and filter visible columns
//             const configuredColumns = allColumns
//                .map((col) => ({
//                   ...col,
//                   config: getColumnInfo(col.defName),
//                }))
//                .filter((col) => col.config.isShow !== false)
//                .sort((a, b) => (a.config.orderNo || 0) - (b.config.orderNo || 0));

//             return configuredColumns;
//          };

//          const columnConfig = getColumnConfig();

//          // Process each company
//          let yPosition = 30;
//          const pageWidth = doc.internal.pageSize.getWidth();
//          const margin = 14;

//          serialWiseHistory.forEach((companyData, companyIndex) => {
//             const groupedItems = groupItemsByItemId(companyData.items);

//             // Check if we need a new page
//             if (yPosition > 180 && companyIndex > 0) {
//                doc.addPage();
//                yPosition = 15;
//             }

//             // Calculate company totals
//             const companyTotals = groupedItems.reduce(
//                (acc, item) => {
//                   const itemTotal = item.transactions.reduce(
//                      (subAcc, transaction) => {
//                         const amount = parseFloat(transaction.line_amount) || 0;
//                         return {
//                            transactions: subAcc.transactions + 1,
//                            amount: subAcc.amount + amount,
//                         };
//                      },
//                      { transactions: 0, amount: 0 },
//                   );
//                   return {
//                      transactions: acc.transactions + itemTotal.transactions,
//                      amount: acc.amount + itemTotal.amount,
//                   };
//                },
//                { transactions: 0, amount: 0 },
//             );

//             yPosition += 5;
//             // Add company total row (like in the image)
//             doc.setFillColor(241, 240, 232); // Light gray background
//             doc.rect(margin, yPosition - 5, pageWidth - 2 * margin, 8, 'F');

//             doc.setFontSize(10);
//             doc.setFont('helvetica', 'bold');
//             doc.setTextColor(0, 0, 0);

//             // Format the company total row similar to the image
//             const companyTotalText = `${companyData.companyName
//                }                             Qty : ${companyTotals.transactions.toLocaleString()}   ||  Amt: ${companyTotals.amount.toLocaleString()}`;
//             doc.text(companyTotalText, margin, yPosition);
//             yPosition += 2;
//             // Prepare headers and column styles from configuration
//             const headers = columnConfig.map((col) => col.config.title);
//             const columnStyles = {};

//             columnConfig.forEach((col, index) => {
//                const alignment = col.isNumeric ? 'right' : col.isDate ? 'center' : 'left';
//                columnStyles[index] = {
//                   cellWidth: 'auto',
//                   halign: alignment,
//                   textColor: col.config.color,
//                   fontStyle: col.config.isBold ? 'bold' : col.config.isItalic ? 'italic' : 'normal',
//                };
//             });

//             // Prepare table data based on view type
//             let tableData = [];

//             const formatCellValue = (value, column) => {
//                if (!value && value !== 0) return '';

//                if (column.isDate && value) {
//                   return formatDateToDDMMYYYY(value);
//                }
//                if (column.isNumeric) {
//                   const numValue = parseFloat(value) || 0;
//                   return column.key.includes('amount') || column.key.includes('rate')
//                      ? `${numValue.toLocaleString()}`
//                      : numValue.toString();
//                }
//                return value.toString();
//             };

//             if (itemWiseSelected?.value === 0) {
//                // Item + Serial-Wise
//                groupedItems.forEach((item) => {
//                   // Add item header row spanning all columns
//                   const itemTotal = item.transactions.reduce(
//                      (sum, trans) => sum + parseFloat(trans.line_amount || 0),
//                      0,
//                   );

//                   // Create item header row with item name and total
//                   const itemHeaderRow = new Array(columnConfig.length).fill('');
//                   itemHeaderRow[0] = {
//                      content: `${item.item_name} - Total Qty: ${item.total_transactions
//                         } | Total Amount: ${itemTotal.toLocaleString()}`,
//                      colSpan: columnConfig.length,
//                      styles: {
//                         fontStyle: 'bold',
//                         fillColor: [230, 230, 230],
//                         textColor: [0, 0, 0],
//                         halign: 'left',
//                      },
//                   };

//                   tableData.push(itemHeaderRow);

//                   // Add transactions for this item
//                   item.transactions.forEach((transaction) => {
//                      const transactionRowData = columnConfig.map((col) => {
//                         const value = transaction[col.accessor];
//                         return formatCellValue(value, col);
//                      });
//                      tableData.push(transactionRowData);
//                   });
//                });
//             } else if (itemWiseSelected?.value === 1) {
//                // Item-wise
//                groupedItems.forEach((item) => {
//                   const itemTotal = item.transactions.reduce(
//                      (sum, trans) => sum + parseFloat(trans.line_amount || 0),
//                      0,
//                   );

//                   const rowData = columnConfig.map((col) => {
//                      if (col.key === 'item_name') return item.item_name;
//                      if (col.key === 'total_transactions') return item.total_transactions.toString();
//                      if (col.key === 'total_amount') return `${itemTotal.toLocaleString()}`;
//                      return '';
//                   });

//                   tableData.push(rowData);
//                });

//                // Add company totals row
//                const totalRowData = columnConfig.map((col) => {
//                   if (col.key === 'item_name') {
//                      return { content: 'Company Total', styles: { fontStyle: 'bold' } };
//                   } else if (col.key === 'total_transactions') {
//                      return { content: companyTotals.transactions.toString(), styles: { fontStyle: 'bold' } };
//                   } else if (col.key === 'total_amount') {
//                      return { content: `${companyTotals.amount.toLocaleString()}`, styles: { fontStyle: 'bold' } };
//                   }
//                   return '';
//                });
//                tableData.push(totalRowData);
//             } else if (itemWiseSelected?.value === 2) {
//                // Serial-Wise - Group by item and show item name as header row
//                groupedItems.forEach((item) => {
//                   // Add item header row spanning all columns
//                   const itemTotal = item.transactions.reduce(
//                      (sum, trans) => sum + parseFloat(trans.line_amount || 0),
//                      0,
//                   );

//                   const itemHeaderRow = new Array(columnConfig.length).fill('');
//                   itemHeaderRow[0] = {
//                      content: `${item.item_name} - Total Amount: ${itemTotal.toLocaleString()}`,
//                      colSpan: columnConfig.length,
//                      styles: {
//                         fontStyle: 'bold',
//                         fillColor: [230, 230, 230],
//                         textColor: [0, 0, 0],
//                         halign: 'left',
//                      },
//                   };

//                   tableData.push(itemHeaderRow);

//                   // Add transactions for this item
//                   item.transactions.forEach((transaction) => {
//                      const rowData = columnConfig.map((col) => {
//                         const value = transaction[col.accessor];
//                         return formatCellValue(value, col);
//                      });
//                      tableData.push(rowData);
//                   });
//                });
//             }

//             // Generate the table
//             doc.autoTable({
//                head: [headers],
//                body: tableData,
//                startY: yPosition,
//                margin: { left: margin, right: margin },
//                styles: {
//                   fontSize: 8,
//                   cellPadding: 2,
//                   overflow: 'linebreak',
//                   valign: 'middle',
//                   textColor: [0, 0, 0],
//                },
//                headStyles: {
//                   fillColor: '#BBBBBB',
//                   textColor: [0, 0, 0],
//                   fontStyle: 'bold',
//                   fontSize: 9,
//                   halign: 'center',
//                },
//                alternateRowStyles: {
//                   fillColor: [248, 250, 252],
//                },
//                columnStyles: columnStyles,
//                didDrawPage: function (data) {
//                   // Footer
//                   const pageCount = doc.internal.getNumberOfPages();
//                   doc.setFontSize(8);
//                   doc.setFont('helvetica', 'bold');
//                   doc.setTextColor(0, 0, 0);
//                   doc.text(
//                      `Page ${data.pageNumber} of ${pageCount}`,
//                      pageWidth - margin,
//                      doc.internal.pageSize.getHeight() - 5,
//                      { align: 'right' },
//                   );
//                },
//             });

//             // Update yPosition for next company
//             yPosition = doc.lastAutoTable.finalY + 10;
//          });

//          // Generate safe file name
//          const now = new Date();
//          const safeFileName = `Item_Serialwise_History_${now.getFullYear()}${(now.getMonth() + 1)
//             .toString()
//             .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

//          // Save the PDF
//          doc.save(safeFileName);
//       } catch (error) {
//          console.error('Error exporting to PDF:', error);
//          alert('Failed to export PDF file. Please try again.');
//       }
//    };

//    const handleViewSingleData = async (id) => {
//       await dispatch(getReceiveInventory(id));
//       setIsOpenSingleViewinr(true);
//    };

//    const handleSalesSingleDataViewClose = () => {
//       setIsOpenSingleViewinr();
//    };

//    const deletePurchaseReturn = () => {
//       if (entityType === 'purchasereturn') {
//          deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
//       }
//       if (entityType === 'salereturn') {
//          deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
//       }
//       if (entityType === 'saleinvoice') {
//          deleteRecordForSales(
//             viewDetail?.id,
//             viewDetail?.daybookId,
//             viewDetail?.accountId,
//             deleteSaleInvoice,
//             dispatch,
//             storedCompanyId,
//             userGlobalSettingsData,
//          );
//       }
//       if (entityType === 'purchaseinvoice') {
//          deleteRecordForSales(
//             viewDetail?.id,
//             viewDetail?.daybookId,
//             viewDetail?.accountId,
//             deletePurchaseInvoice,
//             dispatch,
//             storedCompanyId,
//             userGlobalSettingsData,
//          );
//       }
//       setIsOpenPurchaseReturnSingleView(false);
//    };

//    const handleSalesDetailsClose = () => {
//       setIsOpenPurchaseReturnSingleView();
//    };

//    const handleNextPage = () => {
//       console.log('Next');
//    };
//    const handlePrevPage = () => {
//       console.log('Prev');
//    };

//    useEffect(() => {
//       if (account) {
//          const details = [
//             { label: 'Bill To', value: account?.name || '-' },
//             { label: 'Mobile', value: account?.mobile || '-' },
//             { label: 'PAN', value: account?.panNo || '-' },
//             { label: 'Billing Address', value: account?.address || '-' },
//          ];
//          setDynamicUserDetails(details);
//       }
//    }, [account]);

//    // Memoized render functions

//    const renderCompanyRow = useCallback(
//       (companyData) => {
//          const groupedItems = groupItemsByItemId(companyData.items);
//          const companyTotal = groupedItems.reduce(
//             (acc, item) => {
//                const itemTotal = item.transactions.reduce(
//                   (subAcc, transaction) => {
//                      const amount = parseFloat(transaction.line_amount) || 0;
//                      return {
//                         transactions: subAcc.transactions + 1,
//                         amount: subAcc.amount + amount,
//                      };
//                   },
//                   { transactions: 0, amount: 0 },
//                );
//                return {
//                   transactions: acc.transactions + itemTotal.transactions,
//                   amount: acc.amount + itemTotal.amount,
//                };
//             },
//             { transactions: 0, amount: 0 },
//          );

//          return (
//             <Tr
//                bg={
//                   isDark
//                      ? 'linear-gradient(135deg, #1a1f3a 0%, #2d1b4e 100%)'
//                      : 'linear-gradient(135deg, #f8f9ff 0%, #e8e9ff 100%)'
//                }
//                className="cursor-pointer transition-all duration-300 hover:shadow-lg"
//                borderLeft="6px solid"
//                borderLeftColor={isDark ? '#6366f1' : '#4f46e5'}
//                borderBottom="2px solid"
//                borderBottomColor={isDark ? 'rgba(99, 102, 241, 0.2)' : 'rgba(79, 70, 229, 0.15)'}
//                _hover={{
//                   transform: 'translateX(4px)',
//                   borderLeftColor: isDark ? '#818cf8' : '#6366f1',
//                   bg: isDark
//                      ? 'linear-gradient(135deg, #252b4a 0%, #3d2b5e 100%)'
//                      : 'linear-gradient(135deg, #ffffff 0%, #f0f1ff 100%)',
//                }}
//                onClick={() => toggleExpand(`company-${companyData.companyId}`)}>
//                <Td px={4} colSpan={2}>
//                   <Flex justify="space-between" align="center">
//                      <Text
//                         fontWeight="700"
//                         fontSize="lg"
//                         color={textColor}
//                         textShadow={isDark ? '0 2px 4px rgba(0,0,0,0.3)' : 'none'}>
//                         {companyData.companyName}
//                      </Text>
//                   </Flex>
//                </Td>
//                <Td py={3} colSpan={3} fontSize="15px" fontWeight="600" color={textColor} isNumeric>
//                   <Flex alignItems={'center'} justifyContent="end">
//                      <Flex
//                         alignItems={'center'}
//                         gap={2}
//                         bg={isDark ? 'rgba(99, 102, 241, 0.15)' : 'rgba(79, 70, 229, 0.08)'}
//                         px={3}
//                         py={1}
//                         borderRadius="full">
//                         <Text fontSize="sm" opacity={0.8}>
//                            Total Qty:
//                         </Text>
//                         <Text fontWeight="700">{companyTotal.transactions}</Text>
//                      </Flex>
//                   </Flex>
//                </Td>

//                <Td px={4} colSpan={6} textAlign="right" color={textColor}>
//                   <Flex justify="flex-end" align="center" gap={4}>
//                      <Flex
//                         alignItems="center"
//                         gap={3}
//                         bg={isDark ? 'rgba(99, 102, 241, 0.2)' : 'rgba(79, 70, 229, 0.1)'}
//                         px={4}
//                         py={2}
//                         borderRadius="lg"
//                         border="1px solid"
//                         borderColor={isDark ? 'rgba(99, 102, 241, 0.3)' : 'rgba(79, 70, 229, 0.2)'}>
//                         <Text fontWeight="600" fontSize="sm">
//                            Company Total:
//                         </Text>
//                         <Text fontWeight="700" fontSize="lg" color={isDark ? '#818cf8' : '#4f46e5'}>
//                            ₹{companyTotal?.amount?.toLocaleString('en-IN') || '0'}
//                         </Text>
//                      </Flex>
//                      {expandedItems[`company-${companyData.companyId}`] ? (
//                         <ChevronUpIcon boxSize={5} />
//                      ) : (
//                         <ChevronDownIcon boxSize={5} />
//                      )}
//                   </Flex>
//                </Td>
//             </Tr>
//          );
//       },
//       [expandedItems, itemWiseSelected, textColor, toggleExpand, groupItemsByItemId, isDark],
//    );

//    const renderItemSerialWiseData = useCallback(
//       (groupedItems, companyId) => {
//          const handledata = async (data, datacompanyId) => {
//             const storedCompanyId = localStorage.getItem('companyId');
//             const companyId = parseInt(storedCompanyId);

//             if (datacompanyId === companyId && data.daybook_type === 20) {
//                setEntityType('receivemaster');
//                const response = await dispatch(getReceiveInventory(data.doc_id));
//                await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
//                setIsOpenSingleViewinr(true);
//             }
//             if (datacompanyId === companyId && data.daybook_type === 19) {
//                setEntityType('issuemaster');
//                const response = await dispatch(getIssueInventory(data.doc_id));
//                await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
//                setIsOpenSingleViewinr(true);
//             }
//             if (datacompanyId === companyId && data.daybook_type === 11) {
//                setEntityType('purchaseinvoice');
//                await dispatch(getPurchaseInvoice(data.doc_id));
//                setIsOpenPurchaseReturnSingleView(true);
//             }
//             if (datacompanyId === companyId && data.daybook_type === 5) {
//                setEntityType('saleinvoice');
//                await dispatch(getSaleInvoice(data.doc_id));
//                setIsOpenPurchaseReturnSingleView(true);
//             }
//             if (datacompanyId === companyId && data.daybook_type === 12) {
//                setEntityType('purchasereturn');
//                await dispatch(getSinglePurchaseReturn(data.id));
//                await dispatch(
//                   getSinglePurchaseReturnWithPrevAndNext({
//                      id: data.doc_id,
//                      page: 1,
//                      limit: 1,
//                      sortBy: 'id',
//                      sortOrder: 'desc',
//                   }),
//                );

//                setIsOpenPurchaseReturnSingleView(true);
//             }
//             if (datacompanyId === companyId && data.daybook_type === 6) {
//                setEntityType('salereturn');
//                await dispatch(
//                   getSingleSalesReturnWithPrevAndNext({
//                      id: data.doc_id,
//                      page: 1,
//                      limit: 1,
//                      sortBy: 'id',
//                      sortOrder: 'desc',
//                   }),
//                );
//                setIsOpenPurchaseReturnSingleView(true);
//             }
//          };

//          if (dynamicOptionValues) {
//             const viewJson = dynamicOptionValues?.formatData?.viewJson;

//             const convertBackendColor = (backendColor) => {
//                if (!backendColor) return null;
//                if (backendColor.startsWith('#')) return backendColor;
//                if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
//                if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
//                return backendColor;
//             };

//             const shouldShowColumn = (columnId) => {
//                const viewItem = viewJson.find(
//                   (item) =>
//                      item.defName?.toLowerCase() === columnId.toLowerCase() ||
//                      item.title?.toLowerCase() === columnId.toLowerCase(),
//                );

//                if (viewItem) {
//                   return viewItem.isShow === true || viewItem.isShow === 'true';
//                }

//                return true;
//             };

//             const totalcount = viewJson?.filter((item) => item.isShow)?.length || 0;

//             return (
//                <>
//                   {groupedItems.map((item, itemIndex) => (
//                      <React.Fragment key={`item-${item.item_id}-${itemIndex}`}>
//                         <Tr
//                            bg={
//                               isDark
//                                  ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
//                                  : 'linear-gradient(135deg, #fefefe 0%, #f1f5f9 100%)'
//                            }
//                            cursor="pointer"
//                            borderLeft="4px solid"
//                            borderLeftColor={isDark ? '#10b981' : '#059669'}
//                            transition="all 0.3s"
//                            _hover={{
//                               bg: isDark
//                                  ? 'linear-gradient(135deg, #2d3b4f 0%, #3f4f65 100%)'
//                                  : 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
//                               transform: 'translateX(2px)',
//                               boxShadow: isDark
//                                  ? '0 4px 12px rgba(16, 185, 129, 0.2)'
//                                  : '0 4px 12px rgba(5, 150, 105, 0.15)',
//                            }}
//                            onClick={() => toggleExpand(`item-${item.item_id}-${companyId}`)}>
//                            <Td colSpan={1} p={3} color={textColor}>
//                               <Flex justifyContent="space-between" alignItems="center" pl={2}>
//                                  <Text fontWeight="600" fontSize="md">
//                                     {item.item_name}
//                                  </Text>
//                               </Flex>
//                            </Td>
//                            <Td
//                               py={3}
//                               colSpan={totalcount - 2}
//                               textAlign="right"
//                               fontSize="14px"
//                               fontWeight="600"
//                               color={textColor}>
//                               <Flex justifyContent="flex-end">
//                                  <Flex
//                                     alignItems="center"
//                                     gap={2}
//                                     bg={isDark ? 'rgba(16, 185, 129, 0.15)' : 'rgba(5, 150, 105, 0.08)'}
//                                     px={3}
//                                     py={1}
//                                     borderRadius="full">
//                                     <Text fontSize="sm">Total:</Text>
//                                     <Text fontWeight="700">{item.total_transactions}</Text>
//                                  </Flex>
//                               </Flex>
//                            </Td>
//                            <Td py={3} fontSize="14px" fontWeight="600" color={textColor} isNumeric>
//                               <Flex alignItems={'center'} justifyContent="space-between">
//                                  <Flex
//                                     alignItems={'center'}
//                                     gap={2}
//                                     bg={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.1)'}
//                                     px={3}
//                                     py={1}
//                                     borderRadius="md">
//                                     <Text fontWeight="700" color={isDark ? '#34d399' : '#059669'}>
//                                        ₹
//                                        {item.transactions
//                                           .reduce(
//                                              (sum, transaction) => sum + parseFloat(transaction.line_amount || 0),
//                                              0,
//                                           )
//                                           .toLocaleString()}
//                                     </Text>
//                                  </Flex>
//                                  {expandedItems[`item-${item.item_id}-${companyId}`] ? (
//                                     <ChevronUpIcon boxSize={4} />
//                                  ) : (
//                                     <ChevronDownIcon boxSize={4} />
//                                  )}
//                               </Flex>
//                            </Td>
//                         </Tr>

//                         {expandedItems[`item-${item.item_id}-${companyId}`] && (
//                            <>
//                               <Tr
//                                  bg={isDark ? '#0f172a' : '#f8fafc'}
//                                  borderTop="2px solid"
//                                  borderBottom="2px solid"
//                                  borderColor={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.15)'}>
//                                  {viewJson
//                                     ?.filter((item) => item.isShow)
//                                     ?.map((item, index) => (
//                                        <Td
//                                           key={index}
//                                           py={3}
//                                           fontSize="11px"
//                                           fontWeight="700"
//                                           color={isDark ? '#94a3b8' : '#475569'}
//                                           textAlign={item.defName === 'amt' ? 'right' : 'left'}
//                                           textTransform="uppercase"
//                                           letterSpacing="wider">
//                                           {item.title || item.defName}
//                                        </Td>
//                                     ))}
//                               </Tr>

//                               {item.transactions.map((transaction, transIndex) => {
//                                  const isOddRow = transIndex % 2 !== 0;
//                                  return (
//                                     <Tr
//                                        key={`trans-${transaction.doc_id}-${transIndex}`}
//                                        onClick={() => handledata(transaction, companyId)}
//                                        cursor="pointer"
//                                        bg={
//                                           isOddRow
//                                              ? isDark
//                                                 ? 'rgba(15, 23, 42, 0.6)'
//                                                 : 'rgba(248, 250, 252, 0.5)'
//                                              : 'transparent'
//                                        }
//                                        transition="all 0.2s"
//                                        _hover={{
//                                           bg: isDark ? 'rgba(16, 185, 129, 0.1)' : 'rgba(5, 150, 105, 0.05)',
//                                           transform: 'scale(1.002)',
//                                        }}
//                                        borderLeft="3px solid transparent"
//                                        _hoverBorderLeftColor={isDark ? '#10b981' : '#059669'}>
//                                        {viewJson
//                                           ?.filter((item) => item.isShow)
//                                           ?.map((item, index) => (
//                                              <Td
//                                                 key={index}
//                                                 py={2.5}
//                                                 fontSize="12px"
//                                                 fontWeight={item.isBold ? 'bold' : '500'}
//                                                 fontStyle={item.isItalic ? 'italic' : 'normal'}
//                                                 color={textColor}
//                                                 textAlign={item.defName === 'amt' ? 'right' : 'left'}
//                                                 textColor={convertBackendColor(item.color)}>
//                                                 {item.defName === 'doc' && transaction.doc_no}
//                                                 {item.defName === 'date' &&
//                                                    formatDateToDDMMYYYY(transaction.transaction_at)}
//                                                 {item.defName === 'itemrate' &&
//                                                    '₹ ' + parseFloat(transaction.item_rate || 0).toLocaleString()}
//                                                 {item.defName === 'serialno' && transaction.serial_no}
//                                                 {item.defName === 'party' && transaction.account_name}
//                                                 {item.defName === 'daybook' && transaction.daybook_name}
//                                                 {item.defName === 'quantity' && transaction.quantity_factor}
//                                                 {item.defName === 'amt' &&
//                                                    '₹ ' + parseFloat(transaction.line_amount || 0).toLocaleString()}
//                                              </Td>
//                                           ))}
//                                     </Tr>
//                                  );
//                               })}
//                            </>
//                         )}
//                      </React.Fragment>
//                   ))}
//                </>
//             );
//          } else {
//             return (
//                <>
//                   {groupedItems.map((item, itemIndex) => (
//                      <React.Fragment key={`item-${item.item_id}-${itemIndex}`}>
//                         <Tr
//                            bg={
//                               isDark
//                                  ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
//                                  : 'linear-gradient(135deg, #fefefe 0%, #f1f5f9 100%)'
//                            }
//                            cursor="pointer"
//                            borderLeft="4px solid"
//                            borderLeftColor={isDark ? '#10b981' : '#059669'}
//                            transition="all 0.3s"
//                            _hover={{
//                               bg: isDark
//                                  ? 'linear-gradient(135deg, #2d3b4f 0%, #3f4f65 100%)'
//                                  : 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
//                               transform: 'translateX(2px)',
//                               boxShadow: isDark
//                                  ? '0 4px 12px rgba(16, 185, 129, 0.2)'
//                                  : '0 4px 12px rgba(5, 150, 105, 0.15)',
//                            }}
//                            onClick={() => toggleExpand(`item-${item.item_id}-${companyId}`)}>
//                            <Td colSpan={1} p={3} color={textColor}>
//                               <Flex justifyContent="space-between" alignItems="center" pl={2}>
//                                  <Text fontWeight="600" fontSize="md">
//                                     {item.item_name}
//                                  </Text>
//                               </Flex>
//                            </Td>
//                            <Td py={3} colSpan={6} textAlign="right" fontSize="14px" fontWeight="600" color={textColor}>
//                               <Flex justifyContent="flex-end">
//                                  <Flex
//                                     alignItems="center"
//                                     gap={2}
//                                     bg={isDark ? 'rgba(16, 185, 129, 0.15)' : 'rgba(5, 150, 105, 0.08)'}
//                                     px={3}
//                                     py={1}
//                                     borderRadius="full">
//                                     <Text fontSize="sm">Total:</Text>
//                                     <Text fontWeight="700">{item.total_transactions}</Text>
//                                  </Flex>
//                               </Flex>
//                            </Td>
//                            <Td py={3} fontSize="14px" fontWeight="600" color={textColor} isNumeric>
//                               <Flex alignItems={'center'} justifyContent="space-between">
//                                  <Flex
//                                     alignItems={'center'}
//                                     gap={2}
//                                     bg={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.1)'}
//                                     px={3}
//                                     py={1}
//                                     borderRadius="md">
//                                     <Text fontWeight="700" color={isDark ? '#34d399' : '#059669'}>
//                                        ₹
//                                        {item.transactions
//                                           .reduce(
//                                              (sum, transaction) => sum + parseFloat(transaction.line_amount || 0),
//                                              0,
//                                           )
//                                           .toLocaleString()}
//                                     </Text>
//                                  </Flex>
//                                  {expandedItems[`item-${item.item_id}-${companyId}`] ? (
//                                     <ChevronUpIcon boxSize={4} />
//                                  ) : (
//                                     <ChevronDownIcon boxSize={4} />
//                                  )}
//                               </Flex>
//                            </Td>
//                         </Tr>

//                         {expandedItems[`item-${item.item_id}-${companyId}`] && (
//                            <>
//                               <Tr
//                                  bg={isDark ? '#0f172a' : '#f8fafc'}
//                                  borderTop="2px solid"
//                                  borderBottom="2px solid"
//                                  borderColor={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.15)'}>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Date
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Doc#
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Account
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Serial No
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Day Book
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     isNumeric
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Item Rate
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     isNumeric
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Quantity
//                                  </Td>
//                                  <Td
//                                     py={3}
//                                     fontSize="11px"
//                                     fontWeight="700"
//                                     color={isDark ? '#94a3b8' : '#475569'}
//                                     isNumeric
//                                     textTransform="uppercase"
//                                     letterSpacing="wider">
//                                     Amount
//                                  </Td>
//                               </Tr>

//                               {item.transactions.map((transaction, transIndex) => {
//                                  const isOddRow = transIndex % 2 !== 0;
//                                  return (
//                                     <Tr
//                                        key={`trans-${transaction.doc_id}-${transIndex}`}
//                                        onClick={() => handledata(transaction, companyId)}
//                                        cursor="pointer"
//                                        bg={
//                                           isOddRow
//                                              ? isDark
//                                                 ? 'rgba(15, 23, 42, 0.6)'
//                                                 : 'rgba(248, 250, 252, 0.5)'
//                                              : 'transparent'
//                                        }
//                                        transition="all 0.2s"
//                                        _hover={{
//                                           bg: isDark ? 'rgba(16, 185, 129, 0.1)' : 'rgba(5, 150, 105, 0.05)',
//                                           transform: 'scale(1.002)',
//                                        }}
//                                        borderLeft="3px solid transparent"
//                                        _hoverBorderLeftColor={isDark ? '#10b981' : '#059669'}>
//                                        <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'10%'}>
//                                           {formatDateToDDMMYYYY(transaction.transaction_at)}
//                                        </Td>
//                                        <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'10%'}>
//                                           {transaction.doc_no}
//                                        </Td>
//                                        <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'20%'}>
//                                           {transaction.account_name}
//                                        </Td>
//                                        <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'20%'}>
//                                           {transaction.serial_no}
//                                        </Td>
//                                        <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'20%'}>
//                                           {transaction.daybook_name}
//                                        </Td>
//                                        <Td
//                                           py={2.5}
//                                           fontSize="12px"
//                                           fontWeight={500}
//                                           color={textColor}
//                                           isNumeric
//                                           width={'15%'}>
//                                           ₹{parseFloat(transaction.item_rate || 0).toLocaleString()}
//                                        </Td>
//                                        <Td
//                                           py={2.5}
//                                           fontSize="12px"
//                                           fontWeight={500}
//                                           color={textColor}
//                                           isNumeric
//                                           width={'10%'}>
//                                           {transaction.quantity_factor || 0}
//                                        </Td>
//                                        <Td
//                                           py={2.5}
//                                           fontSize="12px"
//                                           fontWeight={500}
//                                           color={textColor}
//                                           isNumeric
//                                           width={'15%'}>
//                                           ₹{parseFloat(transaction.line_amount || 0).toLocaleString()}
//                                        </Td>
//                                     </Tr>
//                                  );
//                               })}
//                            </>
//                         )}
//                      </React.Fragment>
//                   ))}
//                </>
//             );
//          }
//       },
//       [expandedItems, formatDateToDDMMYYYY, textColor, toggleExpand, isDark],
//    );

//    const renderStockReportContent = useCallback(
//       (companyData) => {
//          const groupedItems = groupItemsByItemId(companyData.items);
//          if (!itemWiseSelected) return null;

//          console.log('itemWiseSelected', itemWiseSelected);

//          return renderItemSerialWiseData(groupedItems, companyData.companyId);
//       },
//       [itemWiseSelected, renderItemSerialWiseData, groupItemsByItemId],
//    );

//    // Memoized report data
//    const memoizedReportData = useMemo(() => {
//       if (!serialWiseHistory || serialWiseHistory.length === 0) return null;

//       return serialWiseHistory.map((companyData, companyIndex) => (
//          <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
//             {renderCompanyRow(companyData)}
//             {expandedItems[`company-${companyData.companyId}`] && renderStockReportContent(companyData)}
//          </React.Fragment>
//       ));
//    }, [serialWiseHistory, expandedItems, renderCompanyRow, renderStockReportContent]);

//    const getColumnsReportsSalesDetail = (formatType, reportType) => {
//       const isPartyReport = reportType === 'party';

//       // Use the passed selectedFormat or fallback to finding from reportformat array
//       // const formatToUse = dynamicOptionValues || dynamicOptionValues.formatData;

//       const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

//       const convertBackendColor = (backendColor) => {
//          if (!backendColor) return null;
//          if (backendColor.startsWith('#')) return backendColor;
//          if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
//          if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
//          return backendColor;
//       };

//       const getColumnInfo = (defName) => {
//          // First try to find by defName, then by title
//          const viewItem = viewJson.find(
//             (item) =>
//                item?.defName?.toLowerCase() === defName.toLowerCase() ||
//                item?.title?.toLowerCase() === defName.toLowerCase(),
//          );

//          if (!viewItem || isStaticReportType) {
//             // Return default values if no customization found or for static report types
//             return {
//                title: defName,
//                isShow: true,
//                color: textColor,
//                isBold: false,
//                isItalic: false,
//                orderNo: 0,
//                flex: 1,
//             };
//          }

//          return {
//             title: viewItem.title || defName,
//             isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
//             color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
//             isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
//             isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
//             orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
//             flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
//          };
//       };

//       const baseColumns = [
//          {
//             id: 'serialNo',
//             header: getColumnInfo('serialNo').title,
//             accessor: 'serialNo',
//             isShow: getColumnInfo('serialNo').isShow,
//             color: getColumnInfo('serialNo').color,
//             isBold: getColumnInfo('serialNo').isBold,
//             isItalic: getColumnInfo('serialNo').isItalic,
//             orderNo: getColumnInfo('serialNo').orderNo,
//             flex: getColumnInfo('serialNo').flex,
//             cell: (info) => {
//                const value = info.getValue();
//                return value ? moment(value).format('DD-MM-YYYY') : value;
//             },
//          },
//          {
//             id: 'transactionAt',
//             header: getColumnInfo('date').title,
//             accessor: 'transactionAt',
//             isShow: getColumnInfo('date').isShow,
//             color: getColumnInfo('date').color,
//             isBold: getColumnInfo('date').isBold,
//             isItalic: getColumnInfo('date').isItalic,
//             orderNo: getColumnInfo('date').orderNo,
//             flex: getColumnInfo('date').flex,
//             cell: (info) => {
//                const value = info.getValue();
//                return value ? moment(value).format('DD-MM-YYYY') : value;
//             },
//          },
//          {
//             id: 'daybookname',
//             header: getColumnInfo('daybook').title,
//             accessor: 'daybookname',
//             isShow: getColumnInfo('daybook').isShow,
//             color: getColumnInfo('daybook').color,
//             isBold: getColumnInfo('daybook').isBold,
//             isItalic: getColumnInfo('daybook').isItalic,
//             orderNo: getColumnInfo('daybook').orderNo,
//             flex: getColumnInfo('daybook').flex,
//          },
//          {
//             id: 'docno',
//             header: getColumnInfo('doc').title,
//             accessor: 'docno',
//             isShow: getColumnInfo('doc').isShow,
//             color: getColumnInfo('doc').color,
//             isBold: getColumnInfo('doc').isBold,
//             isItalic: getColumnInfo('doc').isItalic,
//             orderNo: getColumnInfo('doc').orderNo,
//             flex: getColumnInfo('doc').flex,
//          },
//          {
//             id: 'accountname',
//             header: getColumnInfo('party').title,
//             accessor: 'accountname',
//             isShow: getColumnInfo('party').isShow,
//             color: getColumnInfo('party').color,
//             isBold: getColumnInfo('party').isBold,
//             isItalic: getColumnInfo('party').isItalic,
//             orderNo: getColumnInfo('party').orderNo,
//             flex: getColumnInfo('party').flex,
//          },
//          {
//             id: 'itemrate',
//             header: getColumnInfo('itemrate').title,
//             accessor: 'itemrate',
//             isNumeric: true,
//             isShow: getColumnInfo('itemrate').isShow,
//             color: getColumnInfo('itemrate').color,
//             isBold: getColumnInfo('itemrate').isBold,
//             isItalic: getColumnInfo('itemrate').isItalic,
//             orderNo: getColumnInfo('itemrate').orderNo,
//             flex: getColumnInfo('itemrate').flex,
//             cell: (info) => {
//                const value = info.getValue();
//                return `₹${Number(value || 0).toLocaleString()}`;
//             },
//          },
//          {
//             id: 'quantity',
//             header: getColumnInfo('quantity').title,
//             accessor: 'quantity',
//             isNumeric: true,
//             isShow: getColumnInfo('quantity').isShow,
//             color: getColumnInfo('quantity').color,
//             isBold: getColumnInfo('quantity').isBold,
//             isItalic: getColumnInfo('quantity').isItalic,
//             orderNo: getColumnInfo('quantity').orderNo,
//             flex: getColumnInfo('quantity').flex,
//             cell: (info) => {
//                const value = info.getValue();
//                return `₹${Number(value || 0).toLocaleString()}`;
//             },
//          },
//          {
//             id: 'Amount',
//             header: getColumnInfo('amt').title,
//             accessor: 'Amount',
//             isNumeric: true,
//             isShow: getColumnInfo('amt').isShow,
//             color: getColumnInfo('amt').color,
//             isBold: getColumnInfo('amt').isBold,
//             isItalic: getColumnInfo('amt').isItalic,
//             orderNo: getColumnInfo('amt').orderNo,
//             flex: getColumnInfo('amt').flex,
//             cell: (info) => {
//                const value = info.getValue();
//                return `₹${Number(value || 0).toLocaleString()}`;
//             },
//          },
//       ];

//       // Filter out columns where isShow is false
//       return baseColumns
//          .filter((col) => col.isShow !== false)
//          .sort((a, b) => {
//             const orderA = a.orderNo || 0;
//             const orderB = b.orderNo || 0;
//             return orderA - orderB;
//          });
//    };

//    const dynamicColumns = useMemo(() => {
//       // Assuming reportformat[0] contains your format data
//       const format = reportformat.find((f) => f.id === reportType) || reportformat[0];
//       return getColumnsReportsSalesDetail(formatType, reportType, format);
//    }, [formatType, reportType, reportformat]);

//    const columnsData = useMemo(() => {
//       return dynamicColumns.map((col, index) => ({
//          key: col?.id,
//          label: col?.header,
//          title: col?.header,
//          width: col?.width,
//          index: index + 1,
//          status: true,
//       }));
//    }, [dynamicColumns]);

//    const handleShowHideFormOpen = async () => {
//       setIsShowHideColumn(true);
//       const formatData = reportformat.find((f) => f.title === reportType && f.defName === 'Item + Serial-Wise History');
//       console.log('formatData', formatData, reportType);
//       if (formatData) {
//          setIsEditShowHide(true);
//          setEditData(formatData);
//       } else {
//          setIsEditShowHide(false);
//          setEditData({});
//       }
//    };

//    const staticReportTypeOptions = [{ value: 'Default', label: 'Default' }];

//    const dynamicEditOption = dynamicOptionValues?.formatData.defName;

//    const reportTypeOptions = [
//       ...staticReportTypeOptions,
//       ...(dynamicOptions.length > 0
//          ? [
//             {
//                label: 'Custom Formats',
//                options: dynamicOptions,
//             },
//          ]
//          : []),
//    ];

//    const handleReportTypeChange = (selectedOption) => {
//       console.log('selectedOption', selectedOption);
//       setReportType(selectedOption.value);
//       setExpandedItems({});
//       dispatch(getReportFormat());
//    };

//    const handleDeleteFormat = async (id) => {
//       try {
//          // Call the action creator
//          await dispatch(deleteReportFormat(id));

//          // Reset edit state if this was the currently edited format
//          if (editData?.id === id) {
//             setIsEditShowHide(false);
//             setEditData({});
//          }
//          dispatch(getReportFormat());
//       } catch (error) {
//          // Errors are already handled in the action creator
//          console.error('Delete error:', error);
//       }
//    };

//    const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//          <span>{label}</span>
//          {isDynamic && context === 'menu' && (
//             <button
//                onClick={(e) => {
//                   e.stopPropagation();
//                   handleDeleteFormat(id);
//                }}
//                style={{
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   color: '#ff4d4f',
//                   padding: '0 5px',
//                }}
//                title="Delete this format">
//                <MdDelete />
//             </button>
//          )}
//       </div>
//    );

//    const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

//    return (
//       <>
//          {/* Header */}
//          <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
//             <Flex>
//                <img
//                   src={back}
//                   alt="Go Back"
//                   width="15px"
//                   onClick={() => window.history.back()}
//                   style={{ cursor: 'pointer' }}
//                />
//                <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
//                   Item + Serialwise History
//                </Text>
//             </Flex>
//             <Flex gap={2} alignItems="center">
//                <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
//                   {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
//                </Box>
//                <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
//                   Expand All
//                </Button>
//                <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
//                   Collapse All
//                </Button>
//             </Flex>
//          </Flex>

//          {/* Filters */}
//          <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
//             <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
//                <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
//                   <Box
//                      my={2}
//                      width="300px"
//                      fontSize={'13px'}
//                      mt={5}
//                      fontWeight={500}
//                      display={{ base: 'none', xl: 'block' }}>
//                      <GridItem className="seperator-width">
//                         {renderDynamicDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: companyFilter,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   </Box>
//                </Flex>
//                <Flex flex="3" display={{ base: 'none', xl: 'flex' }}>
//                   <Flex alignItems={'center'} mt={3}>
//                      <PeriodDatePicker
//                         value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
//                         onChange={handleDateRangeChange}
//                         defaultPeriod="last7Days"
//                         style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
//                      />
//                   </Flex>
//                   <Flex>
//                      <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
//                         <label>Format</label>
//                         <Select
//                            options={reportTypeOptions}
//                            formatOptionLabel={formatOptionLabel}
//                            value={reportTypeOptions.find((option) => option.value === reportType)}
//                            onChange={handleReportTypeChange}
//                            placeholder="Select Report Type"
//                            styles={{
//                               control: (baseStyles, state) => ({
//                                  ...baseStyles,
//                                  minHeight: '30px',
//                                  height: '30px',
//                                  backgroundColor: controlBg,
//                                  borderColor: controlBorder,
//                                  boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
//                                  '&:hover': {
//                                     borderColor: controlBorderHover,
//                                  },
//                               }),
//                               valueContainer: (baseStyles) => ({
//                                  ...baseStyles,
//                                  height: '30px',
//                                  padding: '0 6px',
//                                  color: textColor,
//                               }),
//                               indicatorsContainer: (baseStyles) => ({
//                                  ...baseStyles,
//                                  height: '30px',
//                               }),
//                               singleValue: (baseStyles) => ({
//                                  ...baseStyles,
//                                  color: textColor,
//                               }),
//                               placeholder: (baseStyles) => ({
//                                  ...baseStyles,
//                                  color: placeholderColor,
//                               }),
//                               option: (baseStyles, state) => ({
//                                  ...baseStyles,
//                                  backgroundColor: state.isFocused ? optionHoverBg : optionBg,
//                                  color: textColor,
//                                  fontWeight: state.data?.isDynamic ? 'bold' : 'normal', // Style dynamic options differently
//                                  '&:hover': {
//                                     backgroundColor: optionHoverBg,
//                                  },
//                               }),
//                               groupHeading: (baseStyles) => ({
//                                  ...baseStyles,
//                                  backgroundColor: menuBg,
//                                  border: `1px solid ${menuBorder}`,
//                               }),
//                               dropdownIndicator: (baseStyles) => ({
//                                  ...baseStyles,
//                                  color: indicatorColor,
//                                  '&:hover': {
//                                     color: indicatorHoverColor,
//                                  },
//                               }),
//                               clearIndicator: (baseStyles) => ({
//                                  ...baseStyles,
//                                  color: indicatorColor,
//                                  '&:hover': {
//                                     color: indicatorHoverColor,
//                                  },
//                               }),
//                            }}
//                         />
//                      </Box>
//                   </Flex>
//                </Flex>
//                <Flex flex="1"></Flex>
//                <Box flex="" mr={3}>
//                   <MotionFlex
//                      ref={wrapperRef}
//                      align="center"
//                      bg={bg}
//                      borderRadius="full"
//                      cursor="pointer"
//                      px={expanded ? 3 : 0}
//                      w={expanded ? '250px' : '40px'}
//                      h="40px"
//                      transition="all 0.3s ease"
//                      onClick={() => setExpanded(true)}>
//                      <MotionSearchIcon
//                         color={icon}
//                         animate={{ rotate: expanded ? 0 : 90 }}
//                         transition={{ duration: 0.3 }}
//                         style={{
//                            marginRight: expanded ? '8px' : '10px',
//                            marginLeft: expanded ? '0' : '10px',
//                         }}
//                      />
//                      {expanded && (
//                         <InputGroup width="200px">
//                            <Input
//                               placeholder="Search..."
//                               value={searchQuery}
//                               onChange={handleSearchChange}
//                               color={icon}
//                               variant="unstyled"
//                               _focus={{ outline: 'none' }}
//                            />
//                         </InputGroup>
//                      )}
//                   </MotionFlex>
//                </Box>
//                <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
//                   <LuRefreshCcw size={20} mr={2} />
//                </Button>
//                <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
//                   <IoFilterOutline size={22} />
//                </Button>
//                <Popover>
//                   <PopoverTrigger>
//                      <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
//                   </PopoverTrigger>
//                   <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
//                      <PopoverBody p="3">
//                         <Button
//                            width="100%"
//                            variant="ghost"
//                            _hover={{ bg: 'blue.100' }}
//                            onClick={exportToExcel}
//                            justifyContent="space-between"
//                            mb={3}>
//                            <img src={xls} alt="Download XLS" width="30px"></img>
//                            Download Excel
//                         </Button>
//                         <Button
//                            width="100%"
//                            variant="ghost"
//                            _hover={{ bg: 'blue.100' }}
//                            onClick={exportToPdf}
//                            justifyContent="space-between">
//                            <img src={xls} alt="Download pdf" width="30px" mr></img>
//                            Download Pdf
//                         </Button>
//                      </PopoverBody>
//                   </PopoverContent>
//                </Popover>
//                <Box ml="">
//                   <Flex display={{ base: 'block', xl: 'none' }}>
//                      <Button variant="unstyled" onClick={onOpen}>
//                         <Image src={DotIcon} alt="Menu" width="25px" />
//                      </Button>
//                   </Flex>
//                </Box>

//                {/* Mobile Drawer */}
//                <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
//                   <DrawerOverlay />
//                   <DrawerContent borderTopRadius="20px">
//                      <DrawerCloseButton />
//                      <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
//                      <DrawerBody>
//                         <GridItem className="seperator-width">
//                            {renderDynamicDropdown(
//                               'company',
//                               'Company',
//                               lastcompanyOptions,
//                               {
//                                  value: companyFilter,
//                                  onChange: handleCompanyChange,
//                               },
//                               {},
//                               textColor,
//                               false,
//                               'Select company',
//                               true,
//                               undefined,
//                               true,
//                            )}
//                         </GridItem>

//                         <Box alignItems={'center'} mt={3}>
//                            <PeriodDatePicker
//                               value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
//                               onChange={handleDateRangeChange}
//                               defaultPeriod="last7Days"
//                               style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
//                            />
//                         </Box>
//                         <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
//                            Apply Filters
//                         </Button>
//                      </DrawerBody>
//                   </DrawerContent>
//                </Drawer>
//             </Flex>
//          </Box>

//          {/* Table */}
//          <Grid overflow="auto">
//             <Card mt="15px" borderRadius="7px">
//                <Box
//                   overflowX="auto"
//                   className="custom-scrollbar"
//                   position="relative"
//                   minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
//                   maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
//                   <Table variant="simple" color="gray.500" mb="24px" mt="12px">
//                      <Tbody>
//                         {isLoading ? (
//                            <Tr>
//                               <Td colSpan={8} textAlign="center" py="100px">
//                                  <Loader />
//                               </Td>
//                            </Tr>
//                         ) : (
//                            memoizedReportData || (
//                               <Tr>
//                                  <Td colSpan={8} textAlign="center" py={10}>
//                                     <Flex direction="column" align="center" justify="center">
//                                        <img src={nodata} alt="No Data Found" width="200px" height="200px" />
//                                        <Text mt={4}>No item + serialwise history data found</Text>
//                                     </Flex>
//                                  </Td>
//                               </Tr>
//                            )
//                         )}
//                      </Tbody>
//                   </Table>
//                </Box>
//             </Card>
//          </Grid>

//          <SalesDetails
//             isOpen={isOpenPurchaseReturnSingleView}
//             onClose={handleSalesDetailsClose}
//             singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
//             title={
//                entityType === 'saleinvoice'
//                   ? 'Sales Invoice'
//                   : entityType === 'salereturn'
//                      ? 'Sales Return'
//                      : entityType === 'purchaseinvoice'
//                         ? 'Purchase Invoice'
//                         : 'Purchase Return'
//             }
//             entityType={entityType}
//             singleEntity={viewDetail}
//             handlePrevPage={handlePrevPage}
//             handleNextPage={handleNextPage}
//             setIsEditFormOpen={setIsEditFormOpen}
//             setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
//             isEditFormOpen={isEditFormOpen}
//             // paginate={paginateData}
//             viewDetail={viewDetail}
//             lineItems={viewDetail?.lineitems}
//             billTerms={viewDetail?.purchasereturnbillteams}
//             onDelete={deletePurchaseReturn}
//             handleSerchClose={() => {
//                console.log('');
//             }}
//          />

//          <ItemSerialwiseHistoryFilter
//             isOpen={isFilterOpen}
//             onClose={onFilterClose}
//             companyIds={companyIds}
//             fromDate={dateRange.fromDate}
//             toDate={dateRange.toDate}
//             entityType="itemserialwisehistory"
//          />

//          <SalesSingleDataView
//             isOpenSingleView={isOpenSingleViewinr}
//             onClose={handleSalesSingleDataViewClose}
//             entityType={entityType}
//             singleEntity={singleEntity}
//             dynamicUserDetails={dynamicUserDetails}
//             // initialIndex={initialIndex}
//             // invoices={invoices}
//             onEditFormClose={() => setIsOpenSingleViewinr(true)}
//             setIsOpenSingleView={setIsOpenSingleViewinr}
//             isEditFormOpen={isEditFormOpen}
//             setIsEditFormOpen={setIsEditFormOpen}
//             title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
//             handleViewSingleData={handleViewSingleData}
//          />

//          <ColumnShowHide
//             isOpen={isShowHideColumn}
//             onClose={() => setIsShowHideColumn(false)}
//             data={columnsData}
//             setShowHideData={setShowHideData}
//             isedit={isEditShowHide}
//             editData={editData}
//             selectedFormat={reportTypeOptions.dynamicOptions}
//             FixdefName1={'Item + Serial-Wise History'}
//             staticOption={staticOption}
//             dynamicEditOption={dynamicEditOption}
//          />
//       </>
//    );
// };

// export default ItemSerialwiseHistory;

'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   InputGroup,
   Spinner,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorMode,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
} from '@chakra-ui/react';
import Select from 'react-select';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import {
   clearCacheReport,
   deleteReportFormat,
   getReportFormat,
   getReportSerialWiseHistory,
} from '../../../../redux/actions/reports';
import moment from 'moment';
import ColumnShowHide from '../components/Columnshowhide';
import { useBusinessType, useGlobal } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { stockDrop, stockStatusDrop } from 'constants';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { motion } from 'framer-motion';
import { MdCompress, MdDelete, MdExpand } from 'react-icons/md';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { useUser } from 'contexts';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LucideEdit } from 'lucide-react';
import { FiPlusCircle } from 'react-icons/fi';
import { IoFilterOutline } from 'react-icons/io5';
import ItemSerialwiseHistoryFilter from '../components/ItemSerialWiseHistoryFilter';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);
const MIN_LOADING_TIME = 300;
const DEBOUNCE_DELAY = 500;

const ItemSerialwiseHistory = () => {
   // Constants
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Context and Redux
   const { companyList } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const { businessTypes } = useBusinessType();
   const dispatch = useDispatch();
   const serialWiseHistory = useSelector((state) => state.reports?.serialWiseHistory || []);
   const dbName = localStorage.getItem('dbName');

   // Report format
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [reportType, setReportType] = useState('Default');
   const [editData, setEditData] = useState({});
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [showHideData, setShowHideData] = useState({});
   const [formatType, setFormatType] = useState('Default');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');

   const allowedDefNames = ['Item + Serial-Wise History'];
   const dynamicOptions = useMemo(
      () =>
         reportformat
            .filter((item) => item?.defName && allowedDefNames.includes(item?.defName))
            .map((item) => ({
               id: item.id,
               value: item.defName && item.title,
               label: item.title,
               isDynamic: true,
               formatData: item,
            })),
      [reportformat],
   );

   const dynamicOptionValues = useMemo(
      () => dynamicOptions.find((option) => option.value === reportType),
      [dynamicOptions, reportType],
   );

   const isStaticReportType = ['Default'].includes(reportType);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { user } = useUser();
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = useState(null);

   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else {
         return {};
      }
   });

   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;

   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);

   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
            ? viewDatasr?.data[0]
            : entityType === 'saleinvoice'
            ? viewDatasi
            : entityType === 'purchaseinvoice'
            ? viewDatapi
            : null;

      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
            ? viewDatasr?.pagination
            : entityType === 'saleinvoice'
            ? viewDatasi?.pagination
            : entityType === 'purchaseinvoice'
            ? viewDatapi?.pagination
            : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      entityType,
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
   ]);

   // Refs
   const abortControllerRef = useRef(null);
   const wrapperRef = useRef();
   const searchTimeoutRef = useRef();

   // State
   const [allExpanded, setAllExpanded] = useState(false);
   const [itemWiseSelected, setItemWiseSelected] = useState(null);
   const [stockWiseSelected, setStockWiseSelected] = useState(null);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [expandedItems, setExpandedItems] = useState({});
   const [searchQuery, setSearchQuery] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });

   // Disclosures
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [expanded, setExpanded] = useState(false);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   // Initialize expanded state for all items when data loads
   useEffect(() => {
      if (serialWiseHistory.length > 0) {
         const newExpanded = {};
         serialWiseHistory.forEach((companyData) => {
            const companyKey = `company-${companyData.companyId}`;
            newExpanded[companyKey] = true;

            if (companyData.items) {
               companyData.items.forEach((itemData) => {
                  const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
                  newExpanded[itemKey] = true;
               });
            }
         });
         setExpandedItems(newExpanded);
      }
   }, [serialWiseHistory]);

   // Memoized values
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [],
      [companyFilter],
   );

   // Initialize default values
   const storedCompanyId = localStorage.getItem('companyId');
   useEffect(() => {
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }

      if (businessTypes?.businessType === 'MOBILE') {
         setItemWiseSelected({ value: stockDrop[0].id, label: stockDrop[0].name });
         setStockWiseSelected({ value: stockStatusDrop[2].id, label: stockStatusDrop[2].name });
      }
   }, [companyList, businessTypes, storedCompanyId]);

   // Optimized data fetching with proper loading states
   const fetchData = useCallback(
      async (searchTerm = '') => {
         // Validate companyIds
         if (
            !Array.isArray(companyIds) ||
            companyIds.length === 0 ||
            companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0)
         ) {
            console.log('Invalid company IDs, skipping API call');
            return;
         }

         // Cancel previous request
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }

         abortControllerRef.current = new AbortController();
         const startTime = Date.now();

         // Set loading state based on whether it's a search or initial load
         if (searchTerm) {
            setIsFilterLoading(true);
         } else {
            setIsLoading(true);
         }

         try {
            // Filter out any invalid IDs
            const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

            if (dateRange.fromDate && dateRange.toDate && validCompanyIds.length > 0) {
               await dispatch(
                  getReportSerialWiseHistory({
                     companyIds: validCompanyIds.join(','),
                     search: searchTerm.trim(),
                  }),
                  { signal: abortControllerRef.current.signal },
               );
            }
         } catch (error) {
            if (error.name !== 'AbortError') {
               console.error('Error fetching serial wise history:', error);
            }
         } finally {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);

            if (remainingTime > 0) {
               await new Promise((resolve) => setTimeout(resolve, remainingTime));
            }

            setIsLoading(false);
            setIsFilterLoading(false);
            abortControllerRef.current = null;
         }
      },
      [dispatch, companyIds, dateRange],
   );

   // Optimized search handler with proper debouncing
   const handleSearchChange = useCallback(
      (e) => {
         const value = e.target.value;
         setSearchQuery(value);

         // Clear previous timeout
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }

         // Set new timeout for debounced search
         searchTimeoutRef.current = setTimeout(() => {
            fetchData(value);
         }, DEBOUNCE_DELAY);
      },
      [fetchData],
   );

   // Cleanup timeouts on unmount
   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }
      };
   }, []);

   // Auto-fetch data when dependencies change
   useEffect(() => {
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      if (hasValidCompanyIds && hasValidDateRange) {
         fetchData();
      }
   }, [companyIds, dateRange.fromDate, dateRange.toDate]);

   const fetchReportType = useCallback(async () => {
      await dispatch(getReportFormat());
   }, [dispatch]);

   useEffect(() => {
      fetchReportType();
   }, [fetchReportType]);

   // Handlers
   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const expandAll = useCallback(() => {
      const newExpanded = {};
      serialWiseHistory.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         if (companyData.items) {
            companyData.items.forEach((itemData) => {
               const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
               newExpanded[itemKey] = true;
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(true);
   }, [serialWiseHistory]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      serialWiseHistory.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         if (companyData.items) {
            companyData.items.forEach((itemData) => {
               const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
               newExpanded[itemKey] = false;
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(false);
   }, [serialWiseHistory]);

   const handleRefresh = useCallback(() => {
      fetchData(searchQuery);
   }, [fetchData, searchQuery]);

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   }, []);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   }, []);

   // Formatting functions
   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
   }, []);

   // Optimized group items function
   const groupItemsByItemId = useCallback((items) => {
      if (!items) return [];

      const grouped = items.reduce((acc, item) => {
         if (!acc[item.item_id]) {
            acc[item.item_id] = {
               item_id: item.item_id,
               item_name: item.item_name,
               total_transactions: 0,
               transactions: [],
            };
         }

         acc[item.item_id].total_transactions += item.total_transactions;
         acc[item.item_id].transactions.push(...item.transactions);

         return acc;
      }, {});

      return Object.values(grouped);
   }, []);

   // Optimized export functions (keeping the same implementation but adding early returns)
   const exportToExcel = () => {
      if (!serialWiseHistory || serialWiseHistory.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new workbook
         const wb = XLSX.utils.book_new();
         const wsData = [];

         // Check if xlsx-js-style is available for advanced styling
         const hasXLSXStyle = typeof XLSXStyle !== 'undefined' || typeof XLSX.writeFileXLSX !== 'undefined';

         // Helper function to create styled cells
         const createStyledCell = (value, style = {}) => {
            // Basic cell structure
            const cell = {
               v: value,
               t: typeof value === 'number' ? 'n' : 's',
            };

            // Only add styles if xlsx-js-style is available
            if (hasXLSXStyle && style && Object.keys(style).length > 0) {
               cell.s = style;
            }

            return cell;
         };

         // Helper function to convert backend color to Excel RGB (6 digits)
         const convertBackendColorToExcel = (backendColor) => {
            if (!backendColor) return '000000';

            if (backendColor.startsWith('#')) {
               return backendColor.substring(1).toUpperCase().padStart(6, '0');
            }

            if (backendColor.startsWith('0xff') || backendColor.startsWith('0xFF')) {
               const hex = backendColor.substring(4);
               return hex.toUpperCase().padStart(6, '0');
            }

            return '000000';
         };

         // Get column configuration based on static or dynamic format
         const getColumnConfig = () => {
            // For static format, use predefined columns
            if (isStaticReportType) {
               let staticColumns = [];

               if (itemWiseSelected?.value === 0) {
                  // Item + Serial-Wise
                  staticColumns = [
                     { key: 'serial_no', title: 'Serial No', accessor: 'serial_no', width: 20 },
                     { key: 'transaction_at', title: 'Date', accessor: 'transaction_at', isDate: true, width: 15 },
                     { key: 'daybook_name', title: 'Daybook', accessor: 'daybook_name', width: 20 },
                     { key: 'doc_no', title: 'Doc', accessor: 'doc_no', width: 15 },
                     { key: 'account_name', title: 'Party', accessor: 'account_name', width: 25 },
                     { key: 'item_rate', title: 'Item Rate', accessor: 'item_rate', isNumeric: true, width: 15 },
                     {
                        key: 'quantity_factor',
                        title: 'Quantity',
                        accessor: 'quantity_factor',
                        isNumeric: true,
                        width: 15,
                     },
                     { key: 'line_amount', title: 'Amount', accessor: 'line_amount', isNumeric: true, width: 15 },
                  ];
               } else if (itemWiseSelected?.value === 1) {
                  // Item-wise
                  staticColumns = [
                     { key: 'item_name', title: 'Item Name', accessor: 'item_name', width: 30 },
                     {
                        key: 'total_transactions',
                        title: 'Quantity',
                        accessor: 'total_transactions',
                        isNumeric: true,
                        width: 20,
                     },
                     { key: 'total_amount', title: 'Amount', accessor: 'total_amount', isNumeric: true, width: 20 },
                  ];
               } else if (itemWiseSelected?.value === 2) {
                  // Serial-Wise
                  staticColumns = [
                     { key: 'serial_no', title: 'Serial No', accessor: 'serial_no', width: 20 },
                     { key: 'transaction_at', title: 'Date', accessor: 'transaction_at', isDate: true, width: 15 },
                     { key: 'daybook_name', title: 'Daybook', accessor: 'daybook_name', width: 20 },
                     { key: 'doc_no', title: 'Doc', accessor: 'doc_no', width: 15 },
                     { key: 'account_name', title: 'Party', accessor: 'account_name', width: 25 },
                     { key: 'transaction_type', title: 'Transaction Type', accessor: 'transaction_type', width: 20 },
                     { key: 'line_amount', title: 'Amount', accessor: 'line_amount', isNumeric: true, width: 15 },
                  ];
               }

               // Add default styling config for static columns
               return staticColumns.map((col) => ({
                  ...col,
                  config: {
                     title: col.title,
                     isShow: true,
                     color: '000000', // Black for static
                     isBold: false,
                     isItalic: false,
                     orderNo: 0,
                     flex: 1,
                  },
               }));
            }

            // For dynamic format, use configuration from viewJson
            const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

            const getColumnInfo = (defName) => {
               const viewItem = viewJson.find(
                  (item) =>
                     item?.defName?.toLowerCase() === defName.toLowerCase() ||
                     item?.title?.toLowerCase() === defName.toLowerCase(),
               );

               if (!viewItem) {
                  return {
                     title: defName,
                     isShow: true,
                     color: '000000',
                     isBold: false,
                     isItalic: false,
                     orderNo: 0,
                     flex: 1,
                  };
               }

               return {
                  title: viewItem.title || defName,
                  isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
                  color: viewItem.color ? convertBackendColorToExcel(viewItem.color) : '000000',
                  isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
                  isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
                  orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
                  flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
               };
            };

            // Define all possible columns based on view type
            let allColumns = [];

            // Safe access to itemWiseSelected
            const viewValue = itemWiseSelected?.value ?? 0;

            if (viewValue === 0) {
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no', width: 20 },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true, width: 15 },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name', width: 20 },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no', width: 15 },
                  { key: 'account_name', defName: 'party', accessor: 'account_name', width: 25 },
                  { key: 'item_rate', defName: 'itemrate', accessor: 'item_rate', isNumeric: true, width: 15 },
                  {
                     key: 'quantity_factor',
                     defName: 'quantity',
                     accessor: 'quantity_factor',
                     isNumeric: true,
                     width: 15,
                  },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true, width: 15 },
               ];
            } else if (viewValue === 1) {
               allColumns = [
                  { key: 'item_name', defName: 'itemname', accessor: 'item_name', width: 30 },
                  {
                     key: 'total_transactions',
                     defName: 'quantity',
                     accessor: 'total_transactions',
                     isNumeric: true,
                     width: 20,
                  },
                  { key: 'total_amount', defName: 'amt', accessor: 'total_amount', isNumeric: true, width: 20 },
               ];
            } else if (viewValue === 2) {
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no', width: 20 },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true, width: 15 },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name', width: 20 },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no', width: 15 },
                  { key: 'account_name', defName: 'party', accessor: 'account_name', width: 25 },
                  { key: 'transaction_type', defName: 'transactiontype', accessor: 'transaction_type', width: 20 },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true, width: 15 },
               ];
            }

            const configuredColumns = allColumns
               .map((col) => ({ ...col, config: getColumnInfo(col.defName) }))
               .filter((col) => col.config.isShow !== false)
               .sort((a, b) => (a.config.orderNo || 0) - (b.config.orderNo || 0));

            return configuredColumns;
         };

         // Styles for Excel cells - simplified for better compatibility
         const styles = {
            reportTitle: {
               font: { bold: true, sz: 16 },
               alignment: { horizontal: 'center' },
               fill: { fgColor: { rgb: 'FFFFFF' } },
            },
            dateRange: {
               font: { italic: true, sz: 12 },
               alignment: { horizontal: 'center' },
            },
            companyHeader: {
               font: { bold: true, sz: 14, color: { rgb: '0000FF' } },
               fill: { fgColor: { rgb: 'E6E6FA' } },
               alignment: { horizontal: 'left' },
            },
            companyTotals: {
               font: { bold: true, sz: 12, color: { rgb: '0000FF' } },
               fill: { fgColor: { rgb: 'E6E6FA' } },
               alignment: { horizontal: 'left' },
            },
            tableHeader: {
               font: { bold: true, sz: 12 },
               fill: { fgColor: { rgb: 'F1F0E8' } },
               alignment: { horizontal: 'center' },
            },
            itemHeader: {
               font: { bold: true, sz: 11 },
               fill: { fgColor: { rgb: 'E6E6E6' } },
               alignment: { horizontal: 'left' },
            },
            totalRow: {
               font: { bold: true, sz: 11 },
               fill: { fgColor: { rgb: 'D3D3D3' } },
               alignment: { horizontal: 'left' },
            },
            oddRow: {
               font: { sz: 10 },
               fill: { fgColor: { rgb: 'FFFFFF' } },
            },
            evenRow: {
               font: { sz: 10 },
               fill: { fgColor: { rgb: 'F8FAFC' } },
            },
         };

         const columnConfig = getColumnConfig();
         let currentRow = 0;
         const mergeRanges = [];

         // Safe date formatting
         const safeDateFormat = (dateValue) => {
            try {
               if (!dateValue) return '';
               if (typeof formatDateToDDMMYYYY === 'function') {
                  return formatDateToDDMMYYYY(dateValue);
               }
               // Fallback date formatting
               const date = new Date(dateValue);
               if (isNaN(date.getTime())) return dateValue.toString();
               return date.toLocaleDateString('en-GB');
            } catch (error) {
               console.warn('Date formatting error:', error);
               return dateValue?.toString() || '';
            }
         };

         // Helper function to format cell value
         const formatCellValue = (value, column) => {
            try {
               if (value === null || value === undefined) return '';
               if (value === 0) return 0;

               if (column?.isDate && value) {
                  return safeDateFormat(value);
               }
               if (column?.isNumeric) {
                  const numValue = parseFloat(value);
                  return isNaN(numValue) ? 0 : numValue;
               }
               return value.toString();
            } catch (error) {
               console.warn('Cell value formatting error:', error);
               return '';
            }
         };

         // Helper function to get cell style with dynamic formatting
         const getCellStyle = (baseStyle, column, rowIndex = 0) => {
            try {
               let cellStyle = JSON.parse(JSON.stringify(baseStyle));

               // Apply dynamic formatting if available and xlsx-js-style is present
               if (hasXLSXStyle && column?.config) {
                  if (column.config.color && column.config.color !== '000000') {
                     cellStyle.font = cellStyle.font || {};
                     cellStyle.font.color = { rgb: column.config.color };
                  }
                  if (column.config.isBold) {
                     cellStyle.font = cellStyle.font || {};
                     cellStyle.font.bold = true;
                  }
                  if (column.config.isItalic) {
                     cellStyle.font = cellStyle.font || {};
                     cellStyle.font.italic = true;
                  }
               }

               // Apply specific formatting based on column type
               if (column) {
                  if (column.isNumeric) {
                     cellStyle.numFmt = '#,##0.00';
                     cellStyle.alignment = cellStyle.alignment || {};
                     cellStyle.alignment.horizontal = 'right';
                  } else if (column.isDate) {
                     cellStyle.numFmt = 'dd-mm-yyyy';
                     cellStyle.alignment = cellStyle.alignment || {};
                     cellStyle.alignment.horizontal = 'center';
                  } else {
                     cellStyle.alignment = cellStyle.alignment || {};
                     cellStyle.alignment.horizontal = 'left';
                  }
               }

               return cellStyle;
            } catch (error) {
               console.warn('Style generation error:', error);
               return baseStyle;
            }
         };

         // Safe date range formatting
         const fromDateStr = dateRange?.fromDate ? safeDateFormat(dateRange.fromDate) : 'N/A';
         const toDateStr = dateRange?.toDate ? safeDateFormat(dateRange.toDate) : 'N/A';

         // Add report title
         wsData.push([createStyledCell('Item + Serialwise History Report', styles.reportTitle)]);
         mergeRanges.push({
            s: { r: currentRow, c: 0 },
            e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
         });
         currentRow++;

         // Add date range
         wsData.push([createStyledCell(`From ${fromDateStr} to ${toDateStr}`, styles.dateRange)]);
         mergeRanges.push({
            s: { r: currentRow, c: 0 },
            e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
         });
         currentRow++;

         // Add format type if dynamic
         if (!isStaticReportType) {
            wsData.push([createStyledCell(`Format: ${reportType || 'Dynamic'}`, styles.dateRange)]);
            mergeRanges.push({
               s: { r: currentRow, c: 0 },
               e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
            });
            currentRow++;
         }

         wsData.push([]); // Empty row
         currentRow++;

         // Safe data processing with proper null checks
         if (!Array.isArray(serialWiseHistory)) {
            throw new Error('serialWiseHistory is not an array');
         }

         // Process each company
         serialWiseHistory.forEach((companyData, companyIndex) => {
            try {
               if (!companyData || !companyData.items) {
                  console.warn(`Company data at index ${companyIndex} is invalid:`, companyData);
                  return; // Skip invalid company data
               }

               // Group items by item ID
               let groupedItems = [];
               if (typeof groupItemsByItemId === 'function') {
                  groupedItems = groupItemsByItemId(companyData.items);
               } else {
                  // Fallback grouping logic
                  groupedItems = companyData.items.map((item) => ({
                     ...item,
                     transactions: item.transactions || [],
                  }));
               }

               // Calculate company totals with safe arithmetic
               const companyTotals = groupedItems.reduce(
                  (acc, item) => {
                     if (!item || !Array.isArray(item.transactions)) {
                        return acc;
                     }

                     const itemTotal = item.transactions.reduce(
                        (subAcc, transaction) => {
                           const amount = parseFloat(transaction?.line_amount) || 0;
                           return {
                              transactions: subAcc.transactions + 1,
                              amount: subAcc.amount + amount,
                           };
                        },
                        { transactions: 0, amount: 0 },
                     );
                     return {
                        transactions: acc.transactions + itemTotal.transactions,
                        amount: acc.amount + itemTotal.amount,
                     };
                  },
                  { transactions: 0, amount: 0 },
               );

               // Add company header
               const companyName = companyData.companyName || `Company ${companyIndex + 1}`;
               wsData.push([createStyledCell(companyName, styles.companyHeader)]);
               mergeRanges.push({
                  s: { r: currentRow, c: 0 },
                  e: { r: currentRow, c: Math.max(columnConfig.length - 1, 7) },
               });
               currentRow++;

               // Add company totals
               const companyTotalCells = [];
               companyTotalCells.push(createStyledCell('', styles.companyTotals));
               companyTotalCells.push(
                  createStyledCell(`Total Qty: ${companyTotals.transactions}`, styles.companyTotals),
               );
               companyTotalCells.push(
                  createStyledCell(
                     `Total Amount: ₹${companyTotals.amount.toLocaleString('en-IN')}`,
                     styles.companyTotals,
                  ),
               );

               // Fill remaining cells with styled empty cells
               while (companyTotalCells.length < Math.max(columnConfig.length, 8)) {
                  companyTotalCells.push(createStyledCell('', styles.companyTotals));
               }

               wsData.push(companyTotalCells);
               currentRow++;

               wsData.push([]); // Empty row
               currentRow++;

               // Add table headers with column-specific styling
               const headers = columnConfig.map((col) => {
                  const headerStyle = JSON.parse(JSON.stringify(styles.tableHeader));

                  // Apply column-specific styling for dynamic format
                  if (!isStaticReportType && hasXLSXStyle && col.config) {
                     if (col.config.color && col.config.color !== '000000') {
                        headerStyle.font = headerStyle.font || {};
                        headerStyle.font.color = { rgb: col.config.color };
                     }
                     if (col.config.isBold) {
                        headerStyle.font = headerStyle.font || {};
                        headerStyle.font.bold = true;
                     }
                     if (col.config.isItalic) {
                        headerStyle.font = headerStyle.font || {};
                        headerStyle.font.italic = true;
                     }
                  }

                  return createStyledCell(col.config?.title || col.title || col.defName, headerStyle);
               });

               wsData.push(headers);
               currentRow++;

               // Process items based on view type with better error handling
               const viewValue = itemWiseSelected?.value ?? 0;

               if (viewValue === 0) {
                  // Item + Serial-Wise
                  groupedItems.forEach((item, itemIndex) => {
                     try {
                        if (!item || !Array.isArray(item.transactions)) {
                           console.warn(`Item at index ${itemIndex} is invalid:`, item);
                           return;
                        }

                        const itemTotal = item.transactions.reduce(
                           (sum, trans) => sum + (parseFloat(trans?.line_amount) || 0),
                           0,
                        );

                        // Add item header row
                        const itemHeaderRow = [];
                        const itemName = item.item_name || `Item ${itemIndex + 1}`;
                        const totalTransactions = item.total_transactions || item.transactions.length;

                        itemHeaderRow.push(
                           createStyledCell(
                              `${itemName} - Total Qty: ${totalTransactions} | Total Amount: ₹${itemTotal.toLocaleString(
                                 'en-IN',
                              )}`,
                              styles.itemHeader,
                           ),
                        );

                        // Fill remaining cells with styled empty cells
                        for (let i = 1; i < columnConfig.length; i++) {
                           itemHeaderRow.push(createStyledCell('', styles.itemHeader));
                        }

                        wsData.push(itemHeaderRow);
                        mergeRanges.push({
                           s: { r: currentRow, c: 0 },
                           e: { r: currentRow, c: columnConfig.length - 1 },
                        });
                        currentRow++;

                        // Add transactions with column-specific styling
                        item.transactions.forEach((transaction, transIndex) => {
                           try {
                              const baseRowStyle = transIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

                              const transactionRow = columnConfig.map((col) => {
                                 const value = formatCellValue(transaction?.[col.accessor], col);
                                 const cellStyle = getCellStyle(baseRowStyle, col, transIndex);
                                 return createStyledCell(value, cellStyle);
                              });

                              wsData.push(transactionRow);
                              currentRow++;
                           } catch (transError) {
                              console.warn(`Error processing transaction ${transIndex}:`, transError);
                           }
                        });

                        wsData.push([]); // Empty row after each item
                        currentRow++;
                     } catch (itemError) {
                        console.warn(`Error processing item ${itemIndex}:`, itemError);
                     }
                  });
               } else if (viewValue === 1) {
                  // Item-wise
                  groupedItems.forEach((item, itemIndex) => {
                     try {
                        const itemTotal =
                           item.transactions?.reduce((sum, trans) => sum + (parseFloat(trans?.line_amount) || 0), 0) ||
                           0;
                        const baseRowStyle = itemIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

                        const rowData = columnConfig.map((col) => {
                           let value = '';
                           if (col.key === 'item_name') value = item.item_name || '';
                           else if (col.key === 'total_transactions')
                              value = item.total_transactions || item.transactions?.length || 0;
                           else if (col.key === 'total_amount') value = itemTotal;

                           const cellStyle = getCellStyle(baseRowStyle, col, itemIndex);
                           return createStyledCell(value, cellStyle);
                        });

                        wsData.push(rowData);
                        currentRow++;
                     } catch (itemError) {
                        console.warn(`Error processing item-wise data ${itemIndex}:`, itemError);
                     }
                  });

                  // Add company totals row
                  const totalRowData = columnConfig.map((col) => {
                     let value = '';
                     if (col.key === 'item_name') value = 'Company Total';
                     else if (col.key === 'total_transactions') value = companyTotals.transactions;
                     else if (col.key === 'total_amount') value = companyTotals.amount;

                     return createStyledCell(value, styles.totalRow);
                  });

                  wsData.push(totalRowData);
                  currentRow++;
               } else if (viewValue === 2) {
                  // Serial-Wise
                  groupedItems.forEach((item, itemIndex) => {
                     try {
                        if (!item || !Array.isArray(item.transactions)) {
                           return;
                        }

                        const itemTotal = item.transactions.reduce(
                           (sum, trans) => sum + (parseFloat(trans?.line_amount) || 0),
                           0,
                        );

                        // Add item header row
                        const itemHeaderRow = [];
                        const itemName = item.item_name || `Item ${itemIndex + 1}`;
                        itemHeaderRow.push(
                           createStyledCell(
                              `${itemName} - Total Amount: ₹${itemTotal.toLocaleString('en-IN')}`,
                              styles.itemHeader,
                           ),
                        );

                        // Fill remaining cells with styled empty cells
                        for (let i = 1; i < columnConfig.length; i++) {
                           itemHeaderRow.push(createStyledCell('', styles.itemHeader));
                        }

                        wsData.push(itemHeaderRow);
                        mergeRanges.push({
                           s: { r: currentRow, c: 0 },
                           e: { r: currentRow, c: columnConfig.length - 1 },
                        });
                        currentRow++;

                        // Add transactions with column-specific styling
                        item.transactions.forEach((transaction, transIndex) => {
                           try {
                              const baseRowStyle = transIndex % 2 === 0 ? styles.evenRow : styles.oddRow;

                              const rowData = columnConfig.map((col) => {
                                 const value = formatCellValue(transaction?.[col.accessor], col);
                                 const cellStyle = getCellStyle(baseRowStyle, col, transIndex);
                                 return createStyledCell(value, cellStyle);
                              });

                              wsData.push(rowData);
                              currentRow++;
                           } catch (transError) {
                              console.warn(`Error processing serial transaction ${transIndex}:`, transError);
                           }
                        });

                        wsData.push([]); // Empty row after each item
                        currentRow++;
                     } catch (itemError) {
                        console.warn(`Error processing serial-wise item ${itemIndex}:`, itemError);
                     }
                  });
               }

               wsData.push([]); // Empty row after each company
               currentRow++;
            } catch (companyError) {
               console.warn(`Error processing company ${companyIndex}:`, companyError);
            }
         });

         // Convert wsData to worksheet
         const ws = XLSX.utils.aoa_to_sheet(wsData);

         // Set column widths based on column configuration
         const colWidths = columnConfig.map((col) => ({ wch: col.width || 15 }));
         while (colWidths.length < 8) {
            colWidths.push({ wch: 15 });
         }
         ws['!cols'] = colWidths;

         // Add merge ranges safely
         if (mergeRanges.length > 0) {
            ws['!merges'] = mergeRanges;
         }

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, 'Item Serialwise History');

         // Generate file name safely
         const now = new Date();
         const formatSuffix = isStaticReportType ? '_Static' : '_Dynamic';
         const safeFileName = `Item_Serialwise_History${formatSuffix}_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.xlsx`;

         // Write file - use XLSX.writeFileXLSX if available for styling
         if (hasXLSXStyle && typeof XLSX.writeFileXLSX !== 'undefined') {
            XLSX.writeFileXLSX(wb, safeFileName);
         } else {
            XLSX.writeFile(wb, safeFileName);
         }

         console.log('Excel export completed successfully');
      } catch (error) {
         console.error('Error exporting to Excel:', error);

         // More detailed error information
         if (error.message) {
            alert(`Failed to export Excel file: ${error.message}`);
         } else {
            alert('Failed to export Excel file. Please check the console for details.');
         }

         // Log additional debugging information
         console.log('Debug info:', {
            serialWiseHistoryLength: serialWiseHistory?.length,
            itemWiseSelected: itemWiseSelected,
            dateRange: dateRange,
            dynamicOptionValues: dynamicOptionValues,
            isStaticReportType: isStaticReportType,
         });
      }
   };

   const exportToPdf = () => {
      if (!serialWiseHistory || serialWiseHistory.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
         });

         // Set document properties
         doc.setProperties({
            title: 'Item + Serialwise History Report',
            subject: 'Generated from application',
            author: 'Your Application',
            keywords: 'report, item, serialwise, history',
            creator: 'Your Application',
         });

         // Get page width for centering
         const pdfWidth = doc.internal.pageSize.getWidth();

         // Add title and date range
         doc.setFontSize(16);
         doc.setTextColor(0, 0, 0);
         doc.setFont('helvetica', 'bold');

         // Calculate center position for title
         const title = 'Item + Serialwise History Report';
         const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
         const titleX = (pdfWidth - titleWidth) / 2;
         doc.text(title, titleX, 15);

         doc.setFontSize(10);
         doc.setFont('helvetica', 'bold');
         doc.setTextColor(0, 0, 0);

         // Calculate center position for date range
         const dateText = `From ${formatDateToDDMMYYYY(dateRange.fromDate)} to ${formatDateToDDMMYYYY(
            dateRange.toDate,
         )}`;
         const dateWidth = (doc.getStringUnitWidth(dateText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
         const dateX = (pdfWidth - dateWidth) / 2;
         doc.text(dateText, dateX, 22);

         // Get dynamic column configuration
         const getColumnConfig = () => {
            const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

            const convertBackendColor = (backendColor) => {
               if (!backendColor) return [0, 0, 0]; // Default black
               if (backendColor.startsWith('#')) {
                  // Convert hex to RGB array for jsPDF
                  const hex = backendColor.substring(1);
                  const r = parseInt(hex.substring(0, 2), 16);
                  const g = parseInt(hex.substring(2, 4), 16);
                  const b = parseInt(hex.substring(4, 6), 16);
                  return [r, g, b];
               }
               if (backendColor.startsWith('0xff')) {
                  const hex = backendColor.substring(4);
                  const r = parseInt(hex.substring(0, 2), 16);
                  const g = parseInt(hex.substring(2, 4), 16);
                  const b = parseInt(hex.substring(4, 6), 16);
                  return [r, g, b];
               }
               return [0, 0, 0]; // Default black
            };

            const getColumnInfo = (defName) => {
               const viewItem = viewJson.find(
                  (item) =>
                     item?.defName?.toLowerCase() === defName.toLowerCase() ||
                     item?.title?.toLowerCase() === defName.toLowerCase(),
               );

               if (!viewItem || isStaticReportType) {
                  return {
                     title: defName,
                     isShow: true,
                     color: [0, 0, 0],
                     isBold: false,
                     isItalic: false,
                     orderNo: 0,
                     flex: 1,
                  };
               }

               return {
                  title: viewItem.title || defName,
                  isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
                  color: viewItem.color ? convertBackendColor(viewItem.color) : [0, 0, 0],
                  isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
                  isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
                  orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
                  flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
               };
            };

            // Define all possible columns based on view type
            let allColumns = [];

            if (itemWiseSelected?.value === 0) {
               // Item + Serial-Wise columns (excluding item_name as it will be a separate row)
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no' },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name' },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no' },
                  { key: 'account_name', defName: 'party', accessor: 'account_name' },
                  { key: 'item_rate', defName: 'itemrate', accessor: 'item_rate', isNumeric: true },
                  { key: 'quantity_factor', defName: 'quantity', accessor: 'quantity_factor', isNumeric: true },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true },
               ];
            } else if (itemWiseSelected?.value === 1) {
               // Item-wise columns
               allColumns = [
                  { key: 'item_name', defName: 'itemname', accessor: 'item_name' },
                  { key: 'total_transactions', defName: 'quantity', accessor: 'total_transactions', isNumeric: true },
                  { key: 'total_amount', defName: 'amt', accessor: 'total_amount', isNumeric: true },
               ];
            } else if (itemWiseSelected?.value === 2) {
               // Serial-Wise columns (excluding item_name as it will be a separate row)
               allColumns = [
                  { key: 'serial_no', defName: 'serialNo', accessor: 'serial_no' },
                  { key: 'transaction_at', defName: 'date', accessor: 'transaction_at', isDate: true },
                  { key: 'daybook_name', defName: 'daybook', accessor: 'daybook_name' },
                  { key: 'doc_no', defName: 'doc', accessor: 'doc_no' },
                  { key: 'account_name', defName: 'party', accessor: 'account_name' },
                  { key: 'transaction_type', defName: 'transactiontype', accessor: 'transaction_type' },
                  { key: 'line_amount', defName: 'amt', accessor: 'line_amount', isNumeric: true },
               ];
            }

            // Get column configuration and filter visible columns
            const configuredColumns = allColumns
               .map((col) => ({
                  ...col,
                  config: getColumnInfo(col.defName),
               }))
               .filter((col) => col.config.isShow !== false)
               .sort((a, b) => (a.config.orderNo || 0) - (b.config.orderNo || 0));

            return configuredColumns;
         };

         const columnConfig = getColumnConfig();

         // Process each company
         let yPosition = 30;
         const pageWidth = doc.internal.pageSize.getWidth();
         const margin = 14;

         serialWiseHistory.forEach((companyData, companyIndex) => {
            const groupedItems = groupItemsByItemId(companyData.items);

            // Check if we need a new page
            if (yPosition > 180 && companyIndex > 0) {
               doc.addPage();
               yPosition = 15;
            }

            // Calculate company totals
            const companyTotals = groupedItems.reduce(
               (acc, item) => {
                  const itemTotal = item.transactions.reduce(
                     (subAcc, transaction) => {
                        const amount = parseFloat(transaction.line_amount) || 0;
                        return {
                           transactions: subAcc.transactions + 1,
                           amount: subAcc.amount + amount,
                        };
                     },
                     { transactions: 0, amount: 0 },
                  );
                  return {
                     transactions: acc.transactions + itemTotal.transactions,
                     amount: acc.amount + itemTotal.amount,
                  };
               },
               { transactions: 0, amount: 0 },
            );

            yPosition += 5;
            // Add company total row (like in the image)
            doc.setFillColor(241, 240, 232); // Light gray background
            doc.rect(margin, yPosition - 5, pageWidth - 2 * margin, 8, 'F');

            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(0, 0, 0);

            // Format the company total row similar to the image
            const companyTotalText = `${
               companyData.companyName
            }                             Qty : ${companyTotals.transactions.toLocaleString()}   ||  Amt: ${companyTotals.amount.toLocaleString()}`;
            doc.text(companyTotalText, margin, yPosition);
            yPosition += 2;
            // Prepare headers and column styles from configuration
            const headers = columnConfig.map((col) => col.config.title);
            const columnStyles = {};

            columnConfig.forEach((col, index) => {
               const alignment = col.isNumeric ? 'right' : col.isDate ? 'center' : 'left';
               columnStyles[index] = {
                  cellWidth: 'auto',
                  halign: alignment,
                  textColor: col.config.color,
                  fontStyle: col.config.isBold ? 'bold' : col.config.isItalic ? 'italic' : 'normal',
               };
            });

            // Prepare table data based on view type
            let tableData = [];

            const formatCellValue = (value, column) => {
               if (!value && value !== 0) return '';

               if (column.isDate && value) {
                  return formatDateToDDMMYYYY(value);
               }
               if (column.isNumeric) {
                  const numValue = parseFloat(value) || 0;
                  return column.key.includes('amount') || column.key.includes('rate')
                     ? `${numValue.toLocaleString()}`
                     : numValue.toString();
               }
               return value.toString();
            };

            if (itemWiseSelected?.value === 0) {
               // Item + Serial-Wise
               groupedItems.forEach((item) => {
                  // Add item header row spanning all columns
                  const itemTotal = item.transactions.reduce(
                     (sum, trans) => sum + parseFloat(trans.line_amount || 0),
                     0,
                  );

                  // Create item header row with item name and total
                  const itemHeaderRow = new Array(columnConfig.length).fill('');
                  itemHeaderRow[0] = {
                     content: `${item.item_name} - Total Qty: ${
                        item.total_transactions
                     } | Total Amount: ${itemTotal.toLocaleString()}`,
                     colSpan: columnConfig.length,
                     styles: {
                        fontStyle: 'bold',
                        fillColor: [230, 230, 230],
                        textColor: [0, 0, 0],
                        halign: 'left',
                     },
                  };

                  tableData.push(itemHeaderRow);

                  // Add transactions for this item
                  item.transactions.forEach((transaction) => {
                     const transactionRowData = columnConfig.map((col) => {
                        const value = transaction[col.accessor];
                        return formatCellValue(value, col);
                     });
                     tableData.push(transactionRowData);
                  });
               });
            } else if (itemWiseSelected?.value === 1) {
               // Item-wise
               groupedItems.forEach((item) => {
                  const itemTotal = item.transactions.reduce(
                     (sum, trans) => sum + parseFloat(trans.line_amount || 0),
                     0,
                  );

                  const rowData = columnConfig.map((col) => {
                     if (col.key === 'item_name') return item.item_name;
                     if (col.key === 'total_transactions') return item.total_transactions.toString();
                     if (col.key === 'total_amount') return `${itemTotal.toLocaleString()}`;
                     return '';
                  });

                  tableData.push(rowData);
               });

               // Add company totals row
               const totalRowData = columnConfig.map((col) => {
                  if (col.key === 'item_name') {
                     return { content: 'Company Total', styles: { fontStyle: 'bold' } };
                  } else if (col.key === 'total_transactions') {
                     return { content: companyTotals.transactions.toString(), styles: { fontStyle: 'bold' } };
                  } else if (col.key === 'total_amount') {
                     return { content: `${companyTotals.amount.toLocaleString()}`, styles: { fontStyle: 'bold' } };
                  }
                  return '';
               });
               tableData.push(totalRowData);
            } else if (itemWiseSelected?.value === 2) {
               // Serial-Wise - Group by item and show item name as header row
               groupedItems.forEach((item) => {
                  // Add item header row spanning all columns
                  const itemTotal = item.transactions.reduce(
                     (sum, trans) => sum + parseFloat(trans.line_amount || 0),
                     0,
                  );

                  const itemHeaderRow = new Array(columnConfig.length).fill('');
                  itemHeaderRow[0] = {
                     content: `${item.item_name} - Total Amount: ${itemTotal.toLocaleString()}`,
                     colSpan: columnConfig.length,
                     styles: {
                        fontStyle: 'bold',
                        fillColor: [230, 230, 230],
                        textColor: [0, 0, 0],
                        halign: 'left',
                     },
                  };

                  tableData.push(itemHeaderRow);

                  // Add transactions for this item
                  item.transactions.forEach((transaction) => {
                     const rowData = columnConfig.map((col) => {
                        const value = transaction[col.accessor];
                        return formatCellValue(value, col);
                     });
                     tableData.push(rowData);
                  });
               });
            }

            // Generate the table
            doc.autoTable({
               head: [headers],
               body: tableData,
               startY: yPosition,
               margin: { left: margin, right: margin },
               styles: {
                  fontSize: 8,
                  cellPadding: 2,
                  overflow: 'linebreak',
                  valign: 'middle',
                  textColor: [0, 0, 0],
               },
               headStyles: {
                  fillColor: '#BBBBBB',
                  textColor: [0, 0, 0],
                  fontStyle: 'bold',
                  fontSize: 9,
                  halign: 'center',
               },
               alternateRowStyles: {
                  fillColor: [248, 250, 252],
               },
               columnStyles: columnStyles,
               didDrawPage: function (data) {
                  // Footer
                  const pageCount = doc.internal.getNumberOfPages();
                  doc.setFontSize(8);
                  doc.setFont('helvetica', 'bold');
                  doc.setTextColor(0, 0, 0);
                  doc.text(
                     `Page ${data.pageNumber} of ${pageCount}`,
                     pageWidth - margin,
                     doc.internal.pageSize.getHeight() - 5,
                     { align: 'right' },
                  );
               },
            });

            // Update yPosition for next company
            yPosition = doc.lastAutoTable.finalY + 10;
         });

         // Generate safe file name
         const now = new Date();
         const safeFileName = `Item_Serialwise_History_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

         // Save the PDF
         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   };

   // Optimized view single data handler
   const handleViewSingleData = useCallback(
      async (id) => {
         await dispatch(getReceiveInventory(id));
         setIsOpenSingleViewinr(true);
      },
      [dispatch],
   );

   const handleSalesSingleDataViewClose = useCallback(() => {
      setIsOpenSingleViewinr();
   }, []);

   const deletePurchaseReturn = useCallback(() => {
      if (entityType === 'purchasereturn') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'salereturn') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'saleinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deleteSaleInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'purchaseinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deletePurchaseInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      setIsOpenPurchaseReturnSingleView(false);
   }, [entityType, viewDetail, dispatch, user, userGlobalSettingsData, storedCompanyId]);

   const handleSalesDetailsClose = useCallback(() => {
      setIsOpenPurchaseReturnSingleView();
   }, []);

   // Memoized render functions
   const renderCompanyRow = useCallback(
      (companyData) => {
         const groupedItems = groupItemsByItemId(companyData.items);
         const companyTotal = groupedItems.reduce(
            (acc, item) => {
               const itemTotal = item.transactions.reduce(
                  (subAcc, transaction) => {
                     const amount = parseFloat(transaction.line_amount) || 0;
                     return {
                        transactions: subAcc.transactions + 1,
                        amount: subAcc.amount + amount,
                     };
                  },
                  { transactions: 0, amount: 0 },
               );
               return {
                  transactions: acc.transactions + itemTotal.transactions,
                  amount: acc.amount + itemTotal.amount,
               };
            },
            { transactions: 0, amount: 0 },
         );

         return (
            <Tr
               bg={
                  isDark
                     ? 'linear-gradient(135deg, #1a1f3a 0%, #2d1b4e 100%)'
                     : 'linear-gradient(135deg, #f8f9ff 0%, #e8e9ff 100%)'
               }
               className="cursor-pointer transition-all duration-300 hover:shadow-lg"
               borderLeft="6px solid"
               borderLeftColor={isDark ? '#6366f1' : '#4f46e5'}
               borderBottom="2px solid"
               borderBottomColor={isDark ? 'rgba(99, 102, 241, 0.2)' : 'rgba(79, 70, 229, 0.15)'}
               _hover={{
                  transform: 'translateX(4px)',
                  borderLeftColor: isDark ? '#818cf8' : '#6366f1',
                  bg: isDark
                     ? 'linear-gradient(135deg, #252b4a 0%, #3d2b5e 100%)'
                     : 'linear-gradient(135deg, #ffffff 0%, #f0f1ff 100%)',
               }}
               onClick={() => toggleExpand(`company-${companyData.companyId}`)}>
               <Td px={4} colSpan={2}>
                  <Flex justify="space-between" align="center">
                     <Text
                        fontWeight="700"
                        fontSize="lg"
                        color={textColor}
                        textShadow={isDark ? '0 2px 4px rgba(0,0,0,0.3)' : 'none'}>
                        {companyData.companyName}
                     </Text>
                  </Flex>
               </Td>
               <Td py={3} colSpan={3} fontSize="15px" fontWeight="600" color={textColor} isNumeric>
                  <Flex alignItems={'center'} justifyContent="end">
                     <Flex
                        alignItems={'center'}
                        gap={2}
                        bg={isDark ? 'rgba(99, 102, 241, 0.15)' : 'rgba(79, 70, 229, 0.08)'}
                        px={3}
                        py={1}
                        borderRadius="full">
                        <Text fontSize="sm" opacity={0.8}>
                           Total Qty:
                        </Text>
                        <Text fontWeight="700">{companyTotal.transactions}</Text>
                     </Flex>
                  </Flex>
               </Td>
               <Td px={4} colSpan={6} textAlign="right" color={textColor}>
                  <Flex justify="flex-end" align="center" gap={4}>
                     <Flex
                        alignItems="center"
                        gap={3}
                        bg={isDark ? 'rgba(99, 102, 241, 0.2)' : 'rgba(79, 70, 229, 0.1)'}
                        px={4}
                        py={2}
                        borderRadius="lg"
                        border="1px solid"
                        borderColor={isDark ? 'rgba(99, 102, 241, 0.3)' : 'rgba(79, 70, 229, 0.2)'}>
                        <Text fontWeight="600" fontSize="sm">
                           Company Total:
                        </Text>
                        <Text fontWeight="700" fontSize="lg" color={isDark ? '#818cf8' : '#4f46e5'}>
                           ₹{companyTotal?.amount?.toLocaleString('en-IN') || '0'}
                        </Text>
                     </Flex>
                     {expandedItems[`company-${companyData.companyId}`] ? (
                        <ChevronUpIcon boxSize={5} />
                     ) : (
                        <ChevronDownIcon boxSize={5} />
                     )}
                  </Flex>
               </Td>
            </Tr>
         );
      },
      [expandedItems, textColor, toggleExpand, groupItemsByItemId, isDark],
   );

   // Optimized data handler with useCallback
   const handledata = useCallback(
      async (data, datacompanyId) => {
         const storedCompanyId = localStorage.getItem('companyId');
         const companyId = parseInt(storedCompanyId);

         if (datacompanyId === companyId && data.daybook_type === 20) {
            setEntityType('receivemaster');
            const response = await dispatch(getReceiveInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 19) {
            setEntityType('issuemaster');
            const response = await dispatch(getIssueInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 11) {
            setEntityType('purchaseinvoice');
            await dispatch(getPurchaseInvoice(data.doc_id));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 5) {
            setEntityType('saleinvoice');
            await dispatch(getSaleInvoice(data.doc_id));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 12) {
            setEntityType('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (datacompanyId === companyId && data.daybook_type === 6) {
            setEntityType('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
      },
      [dispatch, user],
   );

   const renderItemSerialWiseData = useCallback(
      (groupedItems, companyId) => {
         if (dynamicOptionValues) {
            const viewJson = dynamicOptionValues?.formatData?.viewJson;
            const totalcount = viewJson?.filter((item) => item.isShow)?.length || 0;

            return (
               <>
                  {groupedItems.map((item, itemIndex) => (
                     <React.Fragment key={`item-${item.item_id}-${itemIndex}`}>
                        {/* Item header row */}
                        <Tr
                           bg={
                              isDark
                                 ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
                                 : 'linear-gradient(135deg, #fefefe 0%, #f1f5f9 100%)'
                           }
                           cursor="pointer"
                           borderLeft="4px solid"
                           borderLeftColor={isDark ? '#10b981' : '#059669'}
                           transition="all 0.3s"
                           _hover={{
                              bg: isDark
                                 ? 'linear-gradient(135deg, #2d3b4f 0%, #3f4f65 100%)'
                                 : 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
                              transform: 'translateX(2px)',
                              boxShadow: isDark
                                 ? '0 4px 12px rgba(16, 185, 129, 0.2)'
                                 : '0 4px 12px rgba(5, 150, 105, 0.15)',
                           }}
                           onClick={() => toggleExpand(`item-${item.item_id}-${companyId}`)}>
                           <Td colSpan={1} p={3} color={textColor}>
                              <Flex justifyContent="space-between" alignItems="center" pl={2}>
                                 <Text fontWeight="600" fontSize="md">
                                    {item.item_name}
                                 </Text>
                              </Flex>
                           </Td>
                           <Td
                              py={3}
                              colSpan={totalcount - 2}
                              textAlign="right"
                              fontSize="14px"
                              fontWeight="600"
                              color={textColor}>
                              <Flex justifyContent="flex-end">
                                 <Flex
                                    alignItems="center"
                                    gap={2}
                                    bg={isDark ? 'rgba(16, 185, 129, 0.15)' : 'rgba(5, 150, 105, 0.08)'}
                                    px={3}
                                    py={1}
                                    borderRadius="full">
                                    <Text fontSize="sm">Total:</Text>
                                    <Text fontWeight="700">{item.total_transactions}</Text>
                                 </Flex>
                              </Flex>
                           </Td>
                           <Td py={3} fontSize="14px" fontWeight="600" color={textColor} isNumeric>
                              <Flex alignItems={'center'} justifyContent="space-between">
                                 <Flex
                                    alignItems={'center'}
                                    gap={2}
                                    bg={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.1)'}
                                    px={3}
                                    py={1}
                                    borderRadius="md">
                                    <Text fontWeight="700" color={isDark ? '#34d399' : '#059669'}>
                                       ₹
                                       {item.transactions
                                          .reduce(
                                             (sum, transaction) => sum + parseFloat(transaction.line_amount || 0),
                                             0,
                                          )
                                          .toLocaleString()}
                                    </Text>
                                 </Flex>
                                 {expandedItems[`item-${item.item_id}-${companyId}`] ? (
                                    <ChevronUpIcon boxSize={4} />
                                 ) : (
                                    <ChevronDownIcon boxSize={4} />
                                 )}
                              </Flex>
                           </Td>
                        </Tr>

                        {/* Expanded transactions */}
                        {expandedItems[`item-${item.item_id}-${companyId}`] && (
                           <>
                              <Tr
                                 bg={isDark ? '#0f172a' : '#f8fafc'}
                                 borderTop="2px solid"
                                 borderBottom="2px solid"
                                 borderColor={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.15)'}>
                                 {viewJson
                                    ?.filter((item) => item.isShow)
                                    ?.map((item, index) => (
                                       <Td
                                          key={index}
                                          py={3}
                                          fontSize="11px"
                                          fontWeight="700"
                                          color={isDark ? '#94a3b8' : '#475569'}
                                          textAlign={item.defName === 'amt' ? 'right' : 'left'}
                                          textTransform="uppercase"
                                          letterSpacing="wider">
                                          {item.title || item.defName}
                                       </Td>
                                    ))}
                              </Tr>

                              {item.transactions.map((transaction, transIndex) => {
                                 const isOddRow = transIndex % 2 !== 0;
                                 return (
                                    <Tr
                                       key={`trans-${transaction.doc_id}-${transIndex}`}
                                       onClick={() => handledata(transaction, companyId)}
                                       cursor="pointer"
                                       bg={
                                          isOddRow
                                             ? isDark
                                                ? 'rgba(15, 23, 42, 0.6)'
                                                : 'rgba(248, 250, 252, 0.5)'
                                             : 'transparent'
                                       }
                                       transition="all 0.2s"
                                       _hover={{
                                          bg: isDark ? 'rgba(16, 185, 129, 0.1)' : 'rgba(5, 150, 105, 0.05)',
                                          transform: 'scale(1.002)',
                                       }}
                                       borderLeft="3px solid transparent"
                                       _hoverBorderLeftColor={isDark ? '#10b981' : '#059669'}>
                                       {/* Transaction data cells */}
                                       {viewJson
                                          ?.filter((item) => item.isShow)
                                          ?.map((item, index) => (
                                             <Td
                                                key={index}
                                                py={2.5}
                                                fontSize="12px"
                                                fontWeight={item.isBold ? 'bold' : '500'}
                                                fontStyle={item.isItalic ? 'italic' : 'normal'}
                                                color={textColor}
                                                textAlign={item.defName === 'amt' ? 'right' : 'left'}>
                                                {item.defName === 'doc' && transaction.doc_no}
                                                {item.defName === 'date' &&
                                                   formatDateToDDMMYYYY(transaction.transaction_at)}
                                                {item.defName === 'itemrate' &&
                                                   '₹ ' + parseFloat(transaction.item_rate || 0).toLocaleString()}
                                                {item.defName === 'serialno' && transaction.serial_no}
                                                {item.defName === 'party' && transaction.account_name}
                                                {item.defName === 'daybook' && transaction.daybook_name}
                                                {item.defName === 'quantity' && transaction.quantity_factor}
                                                {item.defName === 'amt' &&
                                                   '₹ ' + parseFloat(transaction.line_amount || 0).toLocaleString()}
                                             </Td>
                                          ))}
                                    </Tr>
                                 );
                              })}
                           </>
                        )}
                     </React.Fragment>
                  ))}
               </>
            );
         } else {
            // Default static view implementation
            return (
               <>
                  {groupedItems.map((item, itemIndex) => (
                     <React.Fragment key={`item-${item.item_id}-${itemIndex}`}>
                        <Tr
                           bg={
                              isDark
                                 ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
                                 : 'linear-gradient(135deg, #fefefe 0%, #f1f5f9 100%)'
                           }
                           cursor="pointer"
                           borderLeft="4px solid"
                           borderLeftColor={isDark ? '#10b981' : '#059669'}
                           transition="all 0.3s"
                           _hover={{
                              bg: isDark
                                 ? 'linear-gradient(135deg, #2d3b4f 0%, #3f4f65 100%)'
                                 : 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
                              transform: 'translateX(2px)',
                              boxShadow: isDark
                                 ? '0 4px 12px rgba(16, 185, 129, 0.2)'
                                 : '0 4px 12px rgba(5, 150, 105, 0.15)',
                           }}
                           onClick={() => toggleExpand(`item-${item.item_id}-${companyId}`)}>
                           <Td colSpan={1} p={3} color={textColor}>
                              <Flex justifyContent="space-between" alignItems="center" pl={2}>
                                 <Text fontWeight="600" fontSize="md">
                                    {item.item_name}
                                 </Text>
                              </Flex>
                           </Td>
                           <Td py={3} colSpan={6} textAlign="right" fontSize="14px" fontWeight="600" color={textColor}>
                              <Flex justifyContent="flex-end">
                                 <Flex
                                    alignItems="center"
                                    gap={2}
                                    bg={isDark ? 'rgba(16, 185, 129, 0.15)' : 'rgba(5, 150, 105, 0.08)'}
                                    px={3}
                                    py={1}
                                    borderRadius="full">
                                    <Text fontSize="sm">Total:</Text>
                                    <Text fontWeight="700">{item.total_transactions}</Text>
                                 </Flex>
                              </Flex>
                           </Td>
                           <Td py={3} fontSize="14px" fontWeight="600" color={textColor} isNumeric>
                              <Flex alignItems={'center'} justifyContent="space-between">
                                 <Flex
                                    alignItems={'center'}
                                    gap={2}
                                    bg={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.1)'}
                                    px={3}
                                    py={1}
                                    borderRadius="md">
                                    <Text fontWeight="700" color={isDark ? '#34d399' : '#059669'}>
                                       ₹
                                       {item.transactions
                                          .reduce(
                                             (sum, transaction) => sum + parseFloat(transaction.line_amount || 0),
                                             0,
                                          )
                                          .toLocaleString()}
                                    </Text>
                                 </Flex>
                                 {expandedItems[`item-${item.item_id}-${companyId}`] ? (
                                    <ChevronUpIcon boxSize={4} />
                                 ) : (
                                    <ChevronDownIcon boxSize={4} />
                                 )}
                              </Flex>
                           </Td>
                        </Tr>

                        {expandedItems[`item-${item.item_id}-${companyId}`] && (
                           <>
                              <Tr
                                 bg={isDark ? '#0f172a' : '#f8fafc'}
                                 borderTop="2px solid"
                                 borderBottom="2px solid"
                                 borderColor={isDark ? 'rgba(16, 185, 129, 0.2)' : 'rgba(5, 150, 105, 0.15)'}>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Date
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Doc#
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Account
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Serial No
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Day Book
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    isNumeric
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Item Rate
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    isNumeric
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Quantity
                                 </Td>
                                 <Td
                                    py={3}
                                    fontSize="11px"
                                    fontWeight="700"
                                    color={isDark ? '#94a3b8' : '#475569'}
                                    isNumeric
                                    textTransform="uppercase"
                                    letterSpacing="wider">
                                    Amount
                                 </Td>
                              </Tr>

                              {item.transactions.map((transaction, transIndex) => {
                                 const isOddRow = transIndex % 2 !== 0;
                                 return (
                                    <Tr
                                       key={`trans-${transaction.doc_id}-${transIndex}`}
                                       onClick={() => handledata(transaction, companyId)}
                                       cursor="pointer"
                                       bg={
                                          isOddRow
                                             ? isDark
                                                ? 'rgba(15, 23, 42, 0.6)'
                                                : 'rgba(248, 250, 252, 0.5)'
                                             : 'transparent'
                                       }
                                       transition="all 0.2s"
                                       _hover={{
                                          bg: isDark ? 'rgba(16, 185, 129, 0.1)' : 'rgba(5, 150, 105, 0.05)',
                                          transform: 'scale(1.002)',
                                       }}
                                       borderLeft="3px solid transparent"
                                       _hoverBorderLeftColor={isDark ? '#10b981' : '#059669'}>
                                       <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'10%'}>
                                          {formatDateToDDMMYYYY(transaction.transaction_at)}
                                       </Td>
                                       <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'10%'}>
                                          {transaction.doc_no}
                                       </Td>
                                       <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'20%'}>
                                          {transaction.account_name}
                                       </Td>
                                       <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'20%'}>
                                          {transaction.serial_no}
                                       </Td>
                                       <Td py={2.5} fontSize="12px" fontWeight={500} color={textColor} width={'20%'}>
                                          {transaction.daybook_name}
                                       </Td>
                                       <Td
                                          py={2.5}
                                          fontSize="12px"
                                          fontWeight={500}
                                          color={textColor}
                                          isNumeric
                                          width={'15%'}>
                                          ₹{parseFloat(transaction.item_rate || 0).toLocaleString()}
                                       </Td>
                                       <Td
                                          py={2.5}
                                          fontSize="12px"
                                          fontWeight={500}
                                          color={textColor}
                                          isNumeric
                                          width={'10%'}>
                                          {transaction.quantity_factor || 0}
                                       </Td>
                                       <Td
                                          py={2.5}
                                          fontSize="12px"
                                          fontWeight={500}
                                          color={textColor}
                                          isNumeric
                                          width={'15%'}>
                                          ₹{parseFloat(transaction.line_amount || 0).toLocaleString()}
                                       </Td>
                                    </Tr>
                                 );
                              })}
                           </>
                        )}
                     </React.Fragment>
                  ))}
               </>
            );
         }
      },
      [expandedItems, formatDateToDDMMYYYY, textColor, toggleExpand, isDark, dynamicOptionValues, handledata],
   );

   const renderStockReportContent = useCallback(
      (companyData) => {
         const groupedItems = groupItemsByItemId(companyData.items);
         if (!itemWiseSelected) return null;
         return renderItemSerialWiseData(groupedItems, companyData.companyId);
      },
      [itemWiseSelected, renderItemSerialWiseData, groupItemsByItemId],
   );

   // Add this after your existing useMemo calls
   const filteredSerialWiseHistory = useMemo(() => {
      if (!searchQuery.trim()) {
         return serialWiseHistory;
      }

      const searchTerm = searchQuery.toLowerCase().trim();

      return serialWiseHistory
         .map((companyData) => {
            // Filter items within each company
            const filteredItems = (companyData.items || []).filter((item) => {
               // Check if item name matches
               if (item.item_name?.toLowerCase().includes(searchTerm)) {
                  return true;
               }

               // Check if any transaction matches the search
               const matchingTransactions = (item.transactions || []).filter(
                  (transaction) =>
                     transaction.serial_no?.toLowerCase().includes(searchTerm) ||
                     transaction.account_name?.toLowerCase().includes(searchTerm) ||
                     transaction.daybook_name?.toLowerCase().includes(searchTerm) ||
                     transaction.doc_no?.toLowerCase().includes(searchTerm),
               );

               return matchingTransactions.length > 0;
            });

            // Only include companies that have matching items
            if (filteredItems.length === 0) {
               return null;
            }

            return {
               ...companyData,
               items: filteredItems,
            };
         })
         .filter(Boolean); // Remove null entries (companies with no matching items)
   }, [serialWiseHistory, searchQuery]);

   // Memoized report data - UPDATED
   const memoizedReportData = useMemo(() => {
      const dataToRender = searchQuery.trim() ? filteredSerialWiseHistory : serialWiseHistory;

      if (!dataToRender || dataToRender.length === 0) {
         return null;
      }

      return dataToRender.map((companyData, companyIndex) => (
         <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
            {renderCompanyRow(companyData)}
            {expandedItems[`company-${companyData.companyId}`] && renderStockReportContent(companyData)}
         </React.Fragment>
      ));
   }, [
      serialWiseHistory,
      filteredSerialWiseHistory,
      expandedItems,
      renderCompanyRow,
      renderStockReportContent,
      searchQuery,
   ]);

   // Report type handlers
   const staticReportTypeOptions = [{ value: 'Default', label: 'Default' }];
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;

   const reportTypeOptions = useMemo(
      () => [
         ...staticReportTypeOptions,
         ...(dynamicOptions.length > 0
            ? [
                 {
                    label: 'Custom Formats',
                    options: dynamicOptions,
                 },
              ]
            : []),
      ],
      [dynamicOptions],
   );

   const handleReportTypeChange = useCallback(
      (selectedOption) => {
         setReportType(selectedOption.value);
         setExpandedItems({});
         dispatch(getReportFormat());
      },
      [dispatch],
   );

   const handleDeleteFormat = useCallback(
      async (id) => {
         try {
            await dispatch(deleteReportFormat(id));
            if (editData?.id === id) {
               setIsEditShowHide(false);
               setEditData({});
            }
            dispatch(getReportFormat());
         } catch (error) {
            console.error('Delete error:', error);
         }
      },
      [dispatch, editData],
   );

   const formatOptionLabel = useCallback(
      ({ label, isDynamic, id }, { context }) => (
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{label}</span>
            {isDynamic && context === 'menu' && (
               <button
                  onClick={(e) => {
                     e.stopPropagation();
                     handleDeleteFormat(id);
                  }}
                  style={{
                     background: 'none',
                     border: 'none',
                     cursor: 'pointer',
                     color: '#ff4d4f',
                     padding: '0 5px',
                  }}
                  title="Delete this format">
                  <MdDelete />
               </button>
            )}
         </div>
      ),
      [handleDeleteFormat],
   );

   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   const handleShowHideFormOpen = useCallback(async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType && f.defName === 'Item + Serial-Wise History');
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   }, [reportType, reportformat]);

   return (
      <>
         {/* Header */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Item + Serialwise History
               </Text>
            </Flex>
            <Flex gap={2} alignItems="center">
               <Box cursor={'pointer'} onClick={handleShowHideFormOpen} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         {/* Filters */}
         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
               <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <Box
                     my={2}
                     width="300px"
                     fontSize={'13px'}
                     mt={5}
                     fontWeight={500}
                     display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </Flex>
               <Flex flex="3" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Flex>
                     <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                        <label>Format</label>
                        <Select
                           options={reportTypeOptions}
                           formatOptionLabel={formatOptionLabel}
                           value={reportTypeOptions.find((option) => option.value === reportType)}
                           onChange={handleReportTypeChange}
                           placeholder="Select Report Type"
                           styles={{
                              control: (baseStyles, state) => ({
                                 ...baseStyles,
                                 minHeight: '30px',
                                 height: '30px',
                                 backgroundColor: controlBg,
                                 borderColor: controlBorder,
                                 boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                                 '&:hover': {
                                    borderColor: controlBorderHover,
                                 },
                              }),
                              valueContainer: (baseStyles) => ({
                                 ...baseStyles,
                                 height: '30px',
                                 padding: '0 6px',
                                 color: textColor,
                              }),
                              indicatorsContainer: (baseStyles) => ({
                                 ...baseStyles,
                                 height: '30px',
                              }),
                              singleValue: (baseStyles) => ({
                                 ...baseStyles,
                                 color: textColor,
                              }),
                              placeholder: (baseStyles) => ({
                                 ...baseStyles,
                                 color: placeholderColor,
                              }),
                              option: (baseStyles, state) => ({
                                 ...baseStyles,
                                 backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                                 color: textColor,
                                 fontWeight: state.data?.isDynamic ? 'bold' : 'normal',
                                 '&:hover': {
                                    backgroundColor: optionHoverBg,
                                 },
                              }),
                              groupHeading: (baseStyles) => ({
                                 ...baseStyles,
                                 backgroundColor: menuBg,
                                 border: `1px solid ${menuBorder}`,
                              }),
                              dropdownIndicator: (baseStyles) => ({
                                 ...baseStyles,
                                 color: indicatorColor,
                                 '&:hover': {
                                    color: indicatorHoverColor,
                                 },
                              }),
                              clearIndicator: (baseStyles) => ({
                                 ...baseStyles,
                                 color: indicatorColor,
                                 '&:hover': {
                                    color: indicatorHoverColor,
                                 },
                              }),
                           }}
                        />
                     </Box>
                  </Flex>
               </Flex>
               <Flex flex="1"></Flex>
               <Box flex="" mr={3}>
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '250px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <InputGroup width="200px">
                           <Input
                              placeholder="Search..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              variant="unstyled"
                              _focus={{ outline: 'none' }}
                           />
                           {isFilterLoading && (
                              <Spinner
                                 size="sm"
                                 position="absolute"
                                 right="8px"
                                 top="50%"
                                 transform="translateY(-50%)"
                              />
                           )}
                        </InputGroup>
                     )}
                  </MotionFlex>
               </Box>
               <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2} isLoading={isLoading}>
                  <LuRefreshCcw size={20} mr={2} />
               </Button>
               <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                  <IoFilterOutline size={22} />
               </Button>
               <Popover>
                  <PopoverTrigger>
                     <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                  </PopoverTrigger>
                  <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                     <PopoverBody p="3">
                        <Button
                           width="100%"
                           variant="ghost"
                           _hover={{ bg: 'blue.100' }}
                           onClick={exportToExcel}
                           justifyContent="space-between"
                           mb={3}>
                           <img src={xls} alt="Download XLS" width="30px"></img>
                           Download Excel
                        </Button>
                        <Button
                           width="100%"
                           variant="ghost"
                           _hover={{ bg: 'blue.100' }}
                           onClick={exportToPdf}
                           justifyContent="space-between">
                           <img src={xls} alt="Download pdf" width="30px" mr></img>
                           Download Pdf
                        </Button>
                     </PopoverBody>
                  </PopoverContent>
               </Popover>
               <Box ml="">
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               {/* Mobile Drawer */}
               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>

                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         {/* Table with loading states */}
         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>
                        {isLoading ? (
                           <Tr>
                              <Td colSpan={8} textAlign="center" py="100px">
                                 <Loader />
                              </Td>
                           </Tr>
                        ) : isFilterLoading ? (
                           <Tr>
                              <Td colSpan={8} textAlign="center" py="50px">
                                 <Flex direction="column" align="center" justify="center">
                                    <Spinner size="lg" mb={4} />
                                    <Text>Searching...</Text>
                                 </Flex>
                              </Td>
                           </Tr>
                        ) : (
                           memoizedReportData || (
                              <Tr>
                                 <Td colSpan={8} textAlign="center" py={10}>
                                    <Flex direction="column" align="center" justify="center">
                                       <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                                       <Text mt={4}>No item + serialwise history data found</Text>
                                    </Flex>
                                 </Td>
                              </Tr>
                           )
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         {/* Modals and other components */}
         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={
               entityType === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityType === 'salereturn'
                  ? 'Sales Return'
                  : entityType === 'purchaseinvoice'
                  ? 'Purchase Invoice'
                  : 'Purchase Return'
            }
            entityType={entityType}
            singleEntity={viewDetail}
            handlePrevPage={() => console.log('Prev')}
            handleNextPage={() => console.log('Next')}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <ItemSerialwiseHistoryFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            entityType="itemserialwisehistory"
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={[]} // You'll need to define columnsData properly
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'Item + Serial-Wise History'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />
      </>
   );
};

export default ItemSerialwiseHistory;
